var map = {
	"./beta/blueprintDrop/0---Always": 35415,
	"./beta/blueprintDrop/0---Always.json": 35415,
	"./beta/blueprintDrop/1---Common": 12213,
	"./beta/blueprintDrop/1---Common.json": 12213,
	"./beta/blueprintDrop/2---Uncommon": 53417,
	"./beta/blueprintDrop/2---Uncommon.json": 53417,
	"./beta/blueprintDrop/3---Rare": 68249,
	"./beta/blueprintDrop/3---Rare.json": 68249,
	"./beta/blueprintDrop/4---Legendary": 64145,
	"./beta/blueprintDrop/4---Legendary.json": 64145,
	"./beta/item/DeployedTrap/000---HorizontalTurret": 56774,
	"./beta/item/DeployedTrap/000---HorizontalTurret.json": 56774,
	"./beta/item/DeployedTrap/001---StandardTurret": 46178,
	"./beta/item/DeployedTrap/001---StandardTurret.json": 46178,
	"./beta/item/DeployedTrap/002---HeavyTurret": 72070,
	"./beta/item/DeployedTrap/002---HeavyTurret.json": 72070,
	"./beta/item/DeployedTrap/003---CeilTurret": 710,
	"./beta/item/DeployedTrap/003---CeilTurret.json": 710,
	"./beta/item/DeployedTrap/004---FireTurret": 32940,
	"./beta/item/DeployedTrap/004---FireTurret.json": 32940,
	"./beta/item/DeployedTrap/005---GroundSaw": 54683,
	"./beta/item/DeployedTrap/005---GroundSaw.json": 54683,
	"./beta/item/DeployedTrap/006---RootTrap": 55700,
	"./beta/item/DeployedTrap/006---RootTrap.json": 55700,
	"./beta/item/DeployedTrap/007---Crusher": 65583,
	"./beta/item/DeployedTrap/007---Crusher.json": 65583,
	"./beta/item/DeployedTrap/008---Decoy": 13055,
	"./beta/item/DeployedTrap/008---Decoy.json": 13055,
	"./beta/item/DeployedTrap/009---PortableDoor": 29757,
	"./beta/item/DeployedTrap/009---PortableDoor.json": 29757,
	"./beta/item/DeployedTrap/010---TeslaCoil": 48925,
	"./beta/item/DeployedTrap/010---TeslaCoil.json": 48925,
	"./beta/item/DeployedTrap/011---Sanctuary": 67227,
	"./beta/item/DeployedTrap/011---Sanctuary.json": 67227,
	"./beta/item/DeployedTrap/012---SanctuaryEmpty": 26109,
	"./beta/item/DeployedTrap/012---SanctuaryEmpty.json": 26109,
	"./beta/item/DeployedTrap/013---DarknessLantern": 99226,
	"./beta/item/DeployedTrap/013---DarknessLantern.json": 99226,
	"./beta/item/Grenade/014---ExplosiveGrenade": 48691,
	"./beta/item/Grenade/014---ExplosiveGrenade.json": 48691,
	"./beta/item/Grenade/015---FastGrenade": 45670,
	"./beta/item/Grenade/015---FastGrenade.json": 45670,
	"./beta/item/Grenade/016---ClusterBomb": 20814,
	"./beta/item/Grenade/016---ClusterBomb.json": 20814,
	"./beta/item/Grenade/017---MagnetGrenade": 6177,
	"./beta/item/Grenade/017---MagnetGrenade.json": 6177,
	"./beta/item/Grenade/018---StunningGrenade": 73671,
	"./beta/item/Grenade/018---StunningGrenade.json": 73671,
	"./beta/item/Grenade/019---IceBomb": 86678,
	"./beta/item/Grenade/019---IceBomb.json": 86678,
	"./beta/item/Grenade/020---FireBomb": 60226,
	"./beta/item/Grenade/020---FireBomb.json": 60226,
	"./beta/item/Grenade/021---RootBomb": 44299,
	"./beta/item/Grenade/021---RootBomb.json": 44299,
	"./beta/item/Grenade/022---OilBomb": 37432,
	"./beta/item/Grenade/022---OilBomb.json": 37432,
	"./beta/item/Grenade/023---SideBomb": 50912,
	"./beta/item/Grenade/023---SideBomb.json": 50912,
	"./beta/item/Grenade/024---Pokebomb": 93321,
	"./beta/item/Grenade/024---Pokebomb.json": 93321,
	"./beta/item/Melee/056---StartSword": 52713,
	"./beta/item/Melee/056---StartSword.json": 52713,
	"./beta/item/Melee/057---AdminWeapon": 38204,
	"./beta/item/Melee/057---AdminWeapon.json": 38204,
	"./beta/item/Melee/058---QuickSword": 34575,
	"./beta/item/Melee/058---QuickSword.json": 34575,
	"./beta/item/Melee/059---RevengeSword": 30078,
	"./beta/item/Melee/059---RevengeSword.json": 30078,
	"./beta/item/Melee/060---BackStabber": 43125,
	"./beta/item/Melee/060---BackStabber.json": 43125,
	"./beta/item/Melee/061---Bleeder": 90367,
	"./beta/item/Melee/061---Bleeder.json": 90367,
	"./beta/item/Melee/062---DualDaggers": 18123,
	"./beta/item/Melee/062---DualDaggers.json": 18123,
	"./beta/item/Melee/063---BroadSword": 12914,
	"./beta/item/Melee/063---BroadSword.json": 12914,
	"./beta/item/Melee/064---Shovel": 92594,
	"./beta/item/Melee/064---Shovel.json": 92594,
	"./beta/item/Melee/065---EvilSword": 64417,
	"./beta/item/Melee/065---EvilSword.json": 64417,
	"./beta/item/Melee/066---BleedCrit": 2142,
	"./beta/item/Melee/066---BleedCrit.json": 2142,
	"./beta/item/Melee/067---SpeedBlade": 41048,
	"./beta/item/Melee/067---SpeedBlade.json": 41048,
	"./beta/item/Melee/068---GiantKiller": 16558,
	"./beta/item/Melee/068---GiantKiller.json": 16558,
	"./beta/item/Melee/069---BulletBlade": 66991,
	"./beta/item/Melee/069---BulletBlade.json": 66991,
	"./beta/item/Melee/070---SismicBlade": 80303,
	"./beta/item/Melee/070---SismicBlade.json": 80303,
	"./beta/item/Melee/071---Spear": 61185,
	"./beta/item/Melee/071---Spear.json": 61185,
	"./beta/item/Melee/072---ImpaleSpear": 58938,
	"./beta/item/Melee/072---ImpaleSpear.json": 58938,
	"./beta/item/Melee/073---KingsSpear": 23530,
	"./beta/item/Melee/073---KingsSpear.json": 23530,
	"./beta/item/Melee/074---Rapier": 21672,
	"./beta/item/Melee/074---Rapier.json": 21672,
	"./beta/item/Melee/075---DashSword": 45306,
	"./beta/item/Melee/075---DashSword.json": 45306,
	"./beta/item/Melee/076---StunMace": 46471,
	"./beta/item/Melee/076---StunMace.json": 46471,
	"./beta/item/Melee/077---BumpBoots": 87474,
	"./beta/item/Melee/077---BumpBoots.json": 87474,
	"./beta/item/Melee/078---SpikedBoots": 15003,
	"./beta/item/Melee/078---SpikedBoots.json": 15003,
	"./beta/item/Melee/079---MultiKickBoots": 2228,
	"./beta/item/Melee/079---MultiKickBoots.json": 2228,
	"./beta/item/Melee/080---QuickFists": 57535,
	"./beta/item/Melee/080---QuickFists.json": 57535,
	"./beta/item/Melee/081---Whip": 10607,
	"./beta/item/Melee/081---Whip.json": 10607,
	"./beta/item/Melee/082---HookWhip": 29930,
	"./beta/item/Melee/082---HookWhip.json": 29930,
	"./beta/item/Melee/083---OilSword": 52043,
	"./beta/item/Melee/083---OilSword.json": 52043,
	"./beta/item/Melee/084---Burner": 36395,
	"./beta/item/Melee/084---Burner.json": 36395,
	"./beta/item/Melee/085---LowHealth": 63792,
	"./beta/item/Melee/085---LowHealth.json": 63792,
	"./beta/item/Melee/086---PerfectHalberd": 58786,
	"./beta/item/Melee/086---PerfectHalberd.json": 58786,
	"./beta/item/Melee/087---BehemothHammer": 94700,
	"./beta/item/Melee/087---BehemothHammer.json": 94700,
	"./beta/item/Melee/088---TentacleWhip": 61925,
	"./beta/item/Melee/088---TentacleWhip.json": 61925,
	"./beta/item/Melee/089---Pan": 55562,
	"./beta/item/Melee/089---Pan.json": 55562,
	"./beta/item/Melee/090---ParryBlade": 75902,
	"./beta/item/Melee/090---ParryBlade.json": 75902,
	"./beta/item/Melee/091---TickScytheLeft": 68509,
	"./beta/item/Melee/091---TickScytheLeft.json": 68509,
	"./beta/item/Melee/092---TickScytheRight": 76155,
	"./beta/item/Melee/092---TickScytheRight.json": 76155,
	"./beta/item/Melee/093---RhythmicBlade": 34053,
	"./beta/item/Melee/093---RhythmicBlade.json": 34053,
	"./beta/item/Melee/094---Crowbar": 33196,
	"./beta/item/Melee/094---Crowbar.json": 33196,
	"./beta/item/Melee/095---Katana": 18796,
	"./beta/item/Melee/095---Katana.json": 18796,
	"./beta/item/Melee/096---ExplosiveCrossBowOffHand": 67700,
	"./beta/item/Melee/096---ExplosiveCrossBowOffHand.json": 67700,
	"./beta/item/Power/026---SlowOrb": 10381,
	"./beta/item/Power/026---SlowOrb.json": 10381,
	"./beta/item/Power/027---Tornado": 50269,
	"./beta/item/Power/027---Tornado.json": 50269,
	"./beta/item/Power/028---KnivesCircle": 9892,
	"./beta/item/Power/028---KnivesCircle.json": 9892,
	"./beta/item/Power/029---DamageBuff": 12951,
	"./beta/item/Power/029---DamageBuff.json": 12951,
	"./beta/item/Power/030---LeechBuff": 88352,
	"./beta/item/Power/030---LeechBuff.json": 88352,
	"./beta/item/Power/031---ExtraHeal": 24728,
	"./beta/item/Power/031---ExtraHeal.json": 24728,
	"./beta/item/Power/032---BulletKiller": 79227,
	"./beta/item/Power/032---BulletKiller.json": 79227,
	"./beta/item/Power/033---Hook": 86475,
	"./beta/item/Power/033---Hook.json": 86475,
	"./beta/item/Power/034---BackBlink": 68001,
	"./beta/item/Power/034---BackBlink.json": 68001,
	"./beta/item/Power/035---TimeDistorsion": 92400,
	"./beta/item/Power/035---TimeDistorsion.json": 92400,
	"./beta/item/Power/036---ToxicCloud": 1667,
	"./beta/item/Power/036---ToxicCloud.json": 1667,
	"./beta/item/Power/037---DamageAura": 25566,
	"./beta/item/Power/037---DamageAura.json": 25566,
	"./beta/item/Power/038---Shockwave": 49022,
	"./beta/item/Power/038---Shockwave.json": 49022,
	"./beta/item/Power/039---Wings": 51110,
	"./beta/item/Power/039---Wings.json": 51110,
	"./beta/item/Power/040---ComboMult": 82161,
	"./beta/item/Power/040---ComboMult.json": 82161,
	"./beta/item/Power/041---Pokecharge": 1701,
	"./beta/item/Power/041---Pokecharge.json": 1701,
	"./beta/item/Power/042---Map": 9668,
	"./beta/item/Power/042---Map.json": 9668,
	"./beta/item/Power/043---Owl": 17295,
	"./beta/item/Power/043---Owl.json": 17295,
	"./beta/item/Power/044---OwlUp": 5820,
	"./beta/item/Power/044---OwlUp.json": 5820,
	"./beta/item/Power/045---Chicken": 53553,
	"./beta/item/Power/045---Chicken.json": 53553,
	"./beta/item/Power/046---SpeedRunner": 45259,
	"./beta/item/Power/046---SpeedRunner.json": 45259,
	"./beta/item/Power/047---Dash": 85889,
	"./beta/item/Power/047---Dash.json": 85889,
	"./beta/item/Power/048---BackDash": 33159,
	"./beta/item/Power/048---BackDash.json": 33159,
	"./beta/item/Power/049---GiantWhistle": 64950,
	"./beta/item/Power/049---GiantWhistle.json": 64950,
	"./beta/item/Power/050---SeismicStomp": 52009,
	"./beta/item/Power/050---SeismicStomp.json": 52009,
	"./beta/item/Power/051---CollectorSpin": 50459,
	"./beta/item/Power/051---CollectorSpin.json": 50459,
	"./beta/item/Power/052---SmokeBomb": 54038,
	"./beta/item/Power/052---SmokeBomb.json": 54038,
	"./beta/item/Power/053---SpawnFriendlyHardy": 23068,
	"./beta/item/Power/053---SpawnFriendlyHardy.json": 23068,
	"./beta/item/Power/054---ExplodeFriendlyHardy": 59018,
	"./beta/item/Power/054---ExplodeFriendlyHardy.json": 59018,
	"./beta/item/Power/055---IceArmor": 72671,
	"./beta/item/Power/055---IceArmor.json": 72671,
	"./beta/item/Ranged/097---StartBow": 33763,
	"./beta/item/Ranged/097---StartBow.json": 33763,
	"./beta/item/Ranged/098---DualBow": 98598,
	"./beta/item/Ranged/098---DualBow.json": 98598,
	"./beta/item/Ranged/099---InfiniteBow": 17435,
	"./beta/item/Ranged/099---InfiniteBow.json": 17435,
	"./beta/item/Ranged/100---LongBow": 68482,
	"./beta/item/Ranged/100---LongBow.json": 68482,
	"./beta/item/Ranged/101---SonicCrossbow": 1397,
	"./beta/item/Ranged/101---SonicCrossbow.json": 1397,
	"./beta/item/Ranged/102---CloseCombatBow": 35302,
	"./beta/item/Ranged/102---CloseCombatBow.json": 35302,
	"./beta/item/Ranged/103---FastBow": 69335,
	"./beta/item/Ranged/103---FastBow.json": 69335,
	"./beta/item/Ranged/104---FrostBow": 54934,
	"./beta/item/Ranged/104---FrostBow.json": 54934,
	"./beta/item/Ranged/105---CrossBow": 79564,
	"./beta/item/Ranged/105---CrossBow.json": 79564,
	"./beta/item/Ranged/106---CrossBowOffHand": 88182,
	"./beta/item/Ranged/106---CrossBowOffHand.json": 88182,
	"./beta/item/Ranged/107---MultiCrossBow": 68057,
	"./beta/item/Ranged/107---MultiCrossBow.json": 68057,
	"./beta/item/Ranged/108---MultiCrossBowOffHand": 80155,
	"./beta/item/Ranged/108---MultiCrossBowOffHand.json": 80155,
	"./beta/item/Ranged/109---FrostCrossBow": 70504,
	"./beta/item/Ranged/109---FrostCrossBow.json": 70504,
	"./beta/item/Ranged/110---FrostCrossBowOffHand": 39132,
	"./beta/item/Ranged/110---FrostCrossBowOffHand.json": 39132,
	"./beta/item/Ranged/111---ExplosiveCrossBow": 99622,
	"./beta/item/Ranged/111---ExplosiveCrossBow.json": 99622,
	"./beta/item/Ranged/112---AlchemicGun": 86569,
	"./beta/item/Ranged/112---AlchemicGun.json": 86569,
	"./beta/item/Ranged/113---Boomerang": 46736,
	"./beta/item/Ranged/113---Boomerang.json": 46736,
	"./beta/item/Ranged/114---BleedAxe": 33683,
	"./beta/item/Ranged/114---BleedAxe.json": 33683,
	"./beta/item/Ranged/115---GodAxe": 2080,
	"./beta/item/Ranged/115---GodAxe.json": 2080,
	"./beta/item/Ranged/116---ThrowingSpear": 69692,
	"./beta/item/Ranged/116---ThrowingSpear.json": 69692,
	"./beta/item/Ranged/117---MarkBow": 25382,
	"./beta/item/Ranged/117---MarkBow.json": 25382,
	"./beta/item/Ranged/118---PreciseBow": 54316,
	"./beta/item/Ranged/118---PreciseBow.json": 54316,
	"./beta/item/Ranged/119---ThrowingKnife": 13420,
	"./beta/item/Ranged/119---ThrowingKnife.json": 13420,
	"./beta/item/Ranged/120---LightningWhip": 27373,
	"./beta/item/Ranged/120---LightningWhip.json": 27373,
	"./beta/item/Ranged/121---ThrowingTorch": 14527,
	"./beta/item/Ranged/121---ThrowingTorch.json": 14527,
	"./beta/item/Ranged/122---ThrowingIce": 84272,
	"./beta/item/Ranged/122---ThrowingIce.json": 84272,
	"./beta/item/Ranged/123---FireBall": 98277,
	"./beta/item/Ranged/123---FireBall.json": 98277,
	"./beta/item/Ranged/124---Lightning": 62981,
	"./beta/item/Ranged/124---Lightning.json": 62981,
	"./beta/item/Ranged/125---FlameThrower": 58460,
	"./beta/item/Ranged/125---FlameThrower.json": 58460,
	"./beta/item/Ranged/126---Freeze": 90677,
	"./beta/item/Ranged/126---Freeze.json": 90677,
	"./beta/item/Ranged/127---MagicSalve": 99356,
	"./beta/item/Ranged/127---MagicSalve.json": 99356,
	"./beta/item/Ranged/128---Blowgun": 93872,
	"./beta/item/Ranged/128---Blowgun.json": 93872,
	"./beta/item/Ranged/129---BarrelLauncher": 86368,
	"./beta/item/Ranged/129---BarrelLauncher.json": 86368,
	"./beta/item/Shield/130---StartShield": 12223,
	"./beta/item/Shield/130---StartShield.json": 12223,
	"./beta/item/Shield/131---WarriorShield": 72454,
	"./beta/item/Shield/131---WarriorShield.json": 72454,
	"./beta/item/Shield/132---Shield": 81420,
	"./beta/item/Shield/132---Shield.json": 81420,
	"./beta/item/Shield/133---AreaShield": 40292,
	"./beta/item/Shield/133---AreaShield.json": 40292,
	"./beta/item/Shield/134---BumpShield": 85905,
	"./beta/item/Shield/134---BumpShield.json": 85905,
	"./beta/item/Shield/135---Rampart": 81512,
	"./beta/item/Shield/135---Rampart.json": 81512,
	"./beta/item/Shield/136---DashShield": 31672,
	"./beta/item/Shield/136---DashShield.json": 31672,
	"./beta/item/Shield/137---BloodShield": 29333,
	"./beta/item/Shield/137---BloodShield.json": 29333,
	"./beta/item/Shield/138---GreedShield": 53087,
	"./beta/item/Shield/138---GreedShield.json": 53087,
	"./beta/item/Shield/139---SpikeShield": 96404,
	"./beta/item/Shield/139---SpikeShield.json": 96404,
	"./beta/item/Shield/140---ParryShield": 58502,
	"./beta/item/Shield/140---ParryShield.json": 58502,
	"./beta/item/Shield/141---HoldShield": 14239,
	"./beta/item/Shield/141---HoldShield.json": 14239,
	"./beta/item/Shield/142---ThunderShield": 39252,
	"./beta/item/Shield/142---ThunderShield.json": 39252,
	"./beta/item/Shield/143---IceShield": 43872,
	"./beta/item/Shield/143---IceShield.json": 43872,
	"./beta/level/MainLevels/00---PrisonStart": 96104,
	"./beta/level/MainLevels/00---PrisonStart.json": 96104,
	"./beta/level/MainLevels/01---PrisonCourtyard": 51769,
	"./beta/level/MainLevels/01---PrisonCourtyard.json": 51769,
	"./beta/level/MainLevels/02---SewerShort": 41158,
	"./beta/level/MainLevels/02---SewerShort.json": 41158,
	"./beta/level/MainLevels/03---PrisonDepths": 2443,
	"./beta/level/MainLevels/03---PrisonDepths.json": 2443,
	"./beta/level/MainLevels/04---PrisonCorrupt": 51639,
	"./beta/level/MainLevels/04---PrisonCorrupt.json": 51639,
	"./beta/level/MainLevels/05---PrisonRoof": 14655,
	"./beta/level/MainLevels/05---PrisonRoof.json": 14655,
	"./beta/level/MainLevels/06---Ossuary": 29308,
	"./beta/level/MainLevels/06---Ossuary.json": 29308,
	"./beta/level/MainLevels/07---SewerDepths": 20254,
	"./beta/level/MainLevels/07---SewerDepths.json": 20254,
	"./beta/level/MainLevels/08---Bridge": 99297,
	"./beta/level/MainLevels/08---Bridge.json": 99297,
	"./beta/level/MainLevels/09---BeholderPit": 10099,
	"./beta/level/MainLevels/09---BeholderPit.json": 10099,
	"./beta/level/MainLevels/10---StiltVillage": 19301,
	"./beta/level/MainLevels/10---StiltVillage.json": 19301,
	"./beta/level/MainLevels/11---AncientTemple": 2648,
	"./beta/level/MainLevels/11---AncientTemple.json": 2648,
	"./beta/level/MainLevels/12---Cemetery": 88824,
	"./beta/level/MainLevels/12---Cemetery.json": 88824,
	"./beta/level/MainLevels/13---ClockTower": 92285,
	"./beta/level/MainLevels/13---ClockTower.json": 92285,
	"./beta/level/MainLevels/14---Crypt": 57467,
	"./beta/level/MainLevels/14---Crypt.json": 57467,
	"./beta/level/MainLevels/15---TopClockTower": 83031,
	"./beta/level/MainLevels/15---TopClockTower.json": 83031,
	"./beta/level/MainLevels/16---Cavern": 93590,
	"./beta/level/MainLevels/16---Cavern.json": 93590,
	"./beta/level/MainLevels/17---Giant": 62930,
	"./beta/level/MainLevels/17---Giant.json": 62930,
	"./beta/level/MainLevels/18---Castle": 43524,
	"./beta/level/MainLevels/18---Castle.json": 43524,
	"./beta/level/MainLevels/19---Distillery": 88244,
	"./beta/level/MainLevels/19---Distillery.json": 88244,
	"./beta/level/MainLevels/20---Throne": 45341,
	"./beta/level/MainLevels/20---Throne.json": 45341,
	"./beta/level/MainLevels/21---Astrolab": 96767,
	"./beta/level/MainLevels/21---Astrolab.json": 96767,
	"./beta/level/MainLevels/22---Observatory": 22431,
	"./beta/level/MainLevels/22---Observatory.json": 22431,
	"./beta/level/MainLevels/23---IllegalLevel": 67684,
	"./beta/level/MainLevels/23---IllegalLevel.json": 67684,
	"./beta/level/MainLevels/24---BoatDock": 22513,
	"./beta/level/MainLevels/24---BoatDock.json": 22513,
	"./beta/level/MainLevels/25---Greenhouse": 27105,
	"./beta/level/MainLevels/25---Greenhouse.json": 27105,
	"./beta/level/MainLevels/26---Swamp": 26038,
	"./beta/level/MainLevels/26---Swamp.json": 26038,
	"./beta/level/MainLevels/27---SwampHeart": 72162,
	"./beta/level/MainLevels/27---SwampHeart.json": 72162,
	"./beta/mob/General/000---Zombie": 8638,
	"./beta/mob/General/000---Zombie.json": 8638,
	"./beta/mob/General/001---FastZombie": 70116,
	"./beta/mob/General/001---FastZombie.json": 70116,
	"./beta/mob/General/002---FlyZombie": 63548,
	"./beta/mob/General/002---FlyZombie.json": 63548,
	"./beta/mob/General/003---S_ZombieFly": 91662,
	"./beta/mob/General/003---S_ZombieFly.json": 91662,
	"./beta/mob/General/004---WormZombie": 25285,
	"./beta/mob/General/004---WormZombie.json": 25285,
	"./beta/mob/General/005---S_Worm": 82112,
	"./beta/mob/General/005---S_Worm.json": 82112,
	"./beta/mob/General/006---S_WallEggWorm": 5450,
	"./beta/mob/General/006---S_WallEggWorm.json": 5450,
	"./beta/mob/General/007---EliteSideKick": 42928,
	"./beta/mob/General/007---EliteSideKick.json": 42928,
	"./beta/mob/General/008---Scorpio": 22619,
	"./beta/mob/General/008---Scorpio.json": 22619,
	"./beta/mob/General/009---Hammer": 62882,
	"./beta/mob/General/009---Hammer.json": 62882,
	"./beta/mob/General/010---S_Fly": 10409,
	"./beta/mob/General/010---S_Fly.json": 10409,
	"./beta/mob/General/011---Grenader": 20141,
	"./beta/mob/General/011---Grenader.json": 20141,
	"./beta/mob/General/012---ClusterGrenader": 36476,
	"./beta/mob/General/012---ClusterGrenader.json": 36476,
	"./beta/mob/General/013---Archer": 87310,
	"./beta/mob/General/013---Archer.json": 87310,
	"./beta/mob/General/014---Ninja": 16132,
	"./beta/mob/General/014---Ninja.json": 16132,
	"./beta/mob/General/015---Runner": 24423,
	"./beta/mob/General/015---Runner.json": 24423,
	"./beta/mob/General/016---LeapingDuelyst": 6124,
	"./beta/mob/General/016---LeapingDuelyst.json": 6124,
	"./beta/mob/General/017---Shield": 8101,
	"./beta/mob/General/017---Shield.json": 8101,
	"./beta/mob/General/018---SpikedSatyr": 89227,
	"./beta/mob/General/018---SpikedSatyr.json": 89227,
	"./beta/mob/General/019---Worm": 98583,
	"./beta/mob/General/019---Worm.json": 98583,
	"./beta/mob/General/020---BatDasher": 53953,
	"./beta/mob/General/020---BatDasher.json": 53953,
	"./beta/mob/General/021---BatKamikaze": 24899,
	"./beta/mob/General/021---BatKamikaze.json": 24899,
	"./beta/mob/General/022---Fly": 68191,
	"./beta/mob/General/022---Fly.json": 68191,
	"./beta/mob/General/023---Shielder": 70356,
	"./beta/mob/General/023---Shielder.json": 70356,
	"./beta/mob/General/024---Comboter": 79638,
	"./beta/mob/General/024---Comboter.json": 79638,
	"./beta/mob/General/025---Hooker": 12696,
	"./beta/mob/General/025---Hooker.json": 12696,
	"./beta/mob/General/026---AxeThrower": 54843,
	"./beta/mob/General/026---AxeThrower.json": 54843,
	"./beta/mob/General/027---Spawner": 67475,
	"./beta/mob/General/027---Spawner.json": 67475,
	"./beta/mob/General/028---Spawnling": 33152,
	"./beta/mob/General/028---Spawnling.json": 33152,
	"./beta/mob/General/029---Spinner": 79374,
	"./beta/mob/General/029---Spinner.json": 79374,
	"./beta/mob/General/030---PirateChief": 57481,
	"./beta/mob/General/030---PirateChief.json": 57481,
	"./beta/mob/General/031---Spiker": 46505,
	"./beta/mob/General/031---Spiker.json": 46505,
	"./beta/mob/General/032---Shocker": 92120,
	"./beta/mob/General/032---Shocker.json": 92120,
	"./beta/mob/General/033---Mage360": 45943,
	"./beta/mob/General/033---Mage360.json": 45943,
	"./beta/mob/General/034---OrbLauncher": 74244,
	"./beta/mob/General/034---OrbLauncher.json": 74244,
	"./beta/mob/General/035---Golem": 4294,
	"./beta/mob/General/035---Golem.json": 4294,
	"./beta/mob/General/036---Fogger": 17845,
	"./beta/mob/General/036---Fogger.json": 17845,
	"./beta/mob/General/037---CastleKnight": 13883,
	"./beta/mob/General/037---CastleKnight.json": 13883,
	"./beta/mob/General/038---Lancer": 28774,
	"./beta/mob/General/038---Lancer.json": 28774,
	"./beta/mob/General/039---DeathMage": 5891,
	"./beta/mob/General/039---DeathMage.json": 5891,
	"./beta/mob/General/040---Skull": 84446,
	"./beta/mob/General/040---Skull.json": 84446,
	"./beta/mob/General/041---KunaiMaster": 96593,
	"./beta/mob/General/041---KunaiMaster.json": 96593,
	"./beta/mob/General/042---Defender": 82025,
	"./beta/mob/General/042---Defender.json": 82025,
	"./beta/mob/General/043---AggressiveZombie": 5744,
	"./beta/mob/General/043---AggressiveZombie.json": 5744,
	"./beta/mob/General/044---Demon": 12681,
	"./beta/mob/General/044---Demon.json": 12681,
	"./beta/mob/General/045---Bomber": 85337,
	"./beta/mob/General/045---Bomber.json": 85337,
	"./beta/mob/General/046---Arbiter": 55061,
	"./beta/mob/General/046---Arbiter.json": 55061,
	"./beta/mob/General/047---Earthquaker": 77244,
	"./beta/mob/General/047---Earthquaker.json": 77244,
	"./beta/mob/General/048---Stomper": 24106,
	"./beta/mob/General/048---Stomper.json": 24106,
	"./beta/mob/General/049---Minimoth": 54149,
	"./beta/mob/General/049---Minimoth.json": 54149,
	"./beta/mob/General/050---KingsFinger": 89630,
	"./beta/mob/General/050---KingsFinger.json": 89630,
	"./beta/mob/General/051---TimeKeeperBot": 5254,
	"./beta/mob/General/051---TimeKeeperBot.json": 5254,
	"./beta/mob/General/052---StompSkeleton": 48894,
	"./beta/mob/General/052---StompSkeleton.json": 48894,
	"./beta/mob/General/053---Rampager": 38033,
	"./beta/mob/General/053---Rampager.json": 38033,
	"./beta/mob/General/054---Librarian": 54847,
	"./beta/mob/General/054---Librarian.json": 54847,
	"./beta/mob/General/055---SewerTtcl": 11688,
	"./beta/mob/General/055---SewerTtcl.json": 11688,
	"./beta/mob/General/056---Pitcher": 54015,
	"./beta/mob/General/056---Pitcher.json": 54015,
	"./beta/mob/General/057---ThrowableMushroom": 24172,
	"./beta/mob/General/057---ThrowableMushroom.json": 24172,
	"./beta/mob/General/058---Fugitive": 21475,
	"./beta/mob/General/058---Fugitive.json": 21475,
	"./beta/mob/General/059---Blowgunner": 21610,
	"./beta/mob/General/059---Blowgunner.json": 21610,
	"./beta/mob/General/060---Tick": 45496,
	"./beta/mob/General/060---Tick.json": 45496,
	"./beta/mob/General/061---Blobby": 16345,
	"./beta/mob/General/061---Blobby.json": 16345,
	"./beta/mob/General/062---Enforcer": 99494,
	"./beta/mob/General/062---Enforcer.json": 99494,
	"./beta/mob/General/063---Duelist": 68451,
	"./beta/mob/General/063---Duelist.json": 68451,
	"./beta/mob/General/064---Samurai": 11665,
	"./beta/mob/General/064---Samurai.json": 11665,
	"./beta/mob/General/065---FatZombie": 71816,
	"./beta/mob/General/065---FatZombie.json": 71816,
	"./beta/mob/General/066---Rat": 81092,
	"./beta/mob/General/066---Rat.json": 81092,
	"./beta/mob/General/067---Mimic": 98212,
	"./beta/mob/General/067---Mimic.json": 98212,
	"./beta/mob/General/068---Hurler": 29368,
	"./beta/mob/General/068---Hurler.json": 29368,
	"./beta/mob/General/069---Behemoth": 37236,
	"./beta/mob/General/069---Behemoth.json": 37236,
	"./beta/mob/General/070---Beholder": 49691,
	"./beta/mob/General/070---Beholder.json": 49691,
	"./beta/mob/General/071---MamaTick": 87141,
	"./beta/mob/General/071---MamaTick.json": 87141,
	"./beta/mob/General/072---BeholderTtcl": 56284,
	"./beta/mob/General/072---BeholderTtcl.json": 56284,
	"./beta/mob/General/073---TimeKeeper": 74941,
	"./beta/mob/General/073---TimeKeeper.json": 74941,
	"./beta/mob/General/074---Giant": 23611,
	"./beta/mob/General/074---Giant.json": 23611,
	"./beta/mob/General/075---GiantEye": 51872,
	"./beta/mob/General/075---GiantEye.json": 51872,
	"./beta/mob/General/076---GiantHand": 46198,
	"./beta/mob/General/076---GiantHand.json": 46198,
	"./beta/mob/General/077---KingsHand": 51450,
	"./beta/mob/General/077---KingsHand.json": 51450,
	"./beta/mob/General/078---Collector": 42906,
	"./beta/mob/General/078---Collector.json": 42906,
	"./beta/mob/General/079---GenericEliteInfos": 66200,
	"./beta/mob/General/079---GenericEliteInfos.json": 66200,
	"./beta/mob/General/080---ExplosiveBarrel": 10097,
	"./beta/mob/General/080---ExplosiveBarrel.json": 10097,
	"./beta/mob/General/081---CrossbowMan": 63387,
	"./beta/mob/General/081---CrossbowMan.json": 63387,
	"./beta/mob/__PROPS__": 91679,
	"./beta/mob/__PROPS__.json": 91679,
	"./beta/mob/__STRUCTURE__": 69095,
	"./beta/mob/__STRUCTURE__.json": 69095,
	"./beta/weapon/00---StartSword": 41836,
	"./beta/weapon/00---StartSword.json": 41836,
	"./beta/weapon/01---AdminWeapon": 46714,
	"./beta/weapon/01---AdminWeapon.json": 46714,
	"./beta/weapon/02---QuickSword": 74865,
	"./beta/weapon/02---QuickSword.json": 74865,
	"./beta/weapon/03---RevengeSword": 81291,
	"./beta/weapon/03---RevengeSword.json": 81291,
	"./beta/weapon/04---BleedCrit": 49353,
	"./beta/weapon/04---BleedCrit.json": 49353,
	"./beta/weapon/05---OilSword": 23726,
	"./beta/weapon/05---OilSword.json": 23726,
	"./beta/weapon/06---Burner": 91111,
	"./beta/weapon/06---Burner.json": 91111,
	"./beta/weapon/07---DualDaggers": 12167,
	"./beta/weapon/07---DualDaggers.json": 12167,
	"./beta/weapon/08---BackStabber": 99209,
	"./beta/weapon/08---BackStabber.json": 99209,
	"./beta/weapon/09---LowHealth": 76723,
	"./beta/weapon/09---LowHealth.json": 76723,
	"./beta/weapon/10---Bleeder": 67549,
	"./beta/weapon/10---Bleeder.json": 67549,
	"./beta/weapon/11---BroadSword": 47735,
	"./beta/weapon/11---BroadSword.json": 47735,
	"./beta/weapon/12---Shovel": 92209,
	"./beta/weapon/12---Shovel.json": 92209,
	"./beta/weapon/13---EvilSword": 8671,
	"./beta/weapon/13---EvilSword.json": 8671,
	"./beta/weapon/14---SpeedBlade": 16612,
	"./beta/weapon/14---SpeedBlade.json": 16612,
	"./beta/weapon/15---GiantKiller": 11802,
	"./beta/weapon/15---GiantKiller.json": 11802,
	"./beta/weapon/16---BulletBlade": 10498,
	"./beta/weapon/16---BulletBlade.json": 10498,
	"./beta/weapon/17---SismicBlade": 35828,
	"./beta/weapon/17---SismicBlade.json": 35828,
	"./beta/weapon/18---StunMace": 85725,
	"./beta/weapon/18---StunMace.json": 85725,
	"./beta/weapon/19---BumpBoots": 91206,
	"./beta/weapon/19---BumpBoots.json": 91206,
	"./beta/weapon/20---SpikedBoots": 42979,
	"./beta/weapon/20---SpikedBoots.json": 42979,
	"./beta/weapon/21---MultiKickBoots": 2608,
	"./beta/weapon/21---MultiKickBoots.json": 2608,
	"./beta/weapon/22---QuickFists": 53211,
	"./beta/weapon/22---QuickFists.json": 53211,
	"./beta/weapon/23---Spear": 29110,
	"./beta/weapon/23---Spear.json": 29110,
	"./beta/weapon/24---ImpaleSpear": 28283,
	"./beta/weapon/24---ImpaleSpear.json": 28283,
	"./beta/weapon/25---KingsSpear": 19672,
	"./beta/weapon/25---KingsSpear.json": 19672,
	"./beta/weapon/26---Rapier": 17456,
	"./beta/weapon/26---Rapier.json": 17456,
	"./beta/weapon/27---PerfectHalberd": 96626,
	"./beta/weapon/27---PerfectHalberd.json": 96626,
	"./beta/weapon/28---BehemothHammer": 95670,
	"./beta/weapon/28---BehemothHammer.json": 95670,
	"./beta/weapon/29---DashSword": 95036,
	"./beta/weapon/29---DashSword.json": 95036,
	"./beta/weapon/30---Whip": 15001,
	"./beta/weapon/30---Whip.json": 15001,
	"./beta/weapon/31---HookWhip": 46160,
	"./beta/weapon/31---HookWhip.json": 46160,
	"./beta/weapon/32---TentacleWhip": 81893,
	"./beta/weapon/32---TentacleWhip.json": 81893,
	"./beta/weapon/33---Pan": 88491,
	"./beta/weapon/33---Pan.json": 88491,
	"./beta/weapon/34---ParryBlade": 80923,
	"./beta/weapon/34---ParryBlade.json": 80923,
	"./beta/weapon/35---TickScytheLeft": 93830,
	"./beta/weapon/35---TickScytheLeft.json": 93830,
	"./beta/weapon/36---TickScytheRight": 19893,
	"./beta/weapon/36---TickScytheRight.json": 19893,
	"./beta/weapon/37---RhythmicBlade": 34562,
	"./beta/weapon/37---RhythmicBlade.json": 34562,
	"./beta/weapon/38---Crowbar": 28154,
	"./beta/weapon/38---Crowbar.json": 28154,
	"./beta/weapon/39---StartBow": 14779,
	"./beta/weapon/39---StartBow.json": 14779,
	"./beta/weapon/40---DualBow": 69319,
	"./beta/weapon/40---DualBow.json": 69319,
	"./beta/weapon/41---InfiniteBow": 41554,
	"./beta/weapon/41---InfiniteBow.json": 41554,
	"./beta/weapon/42---LongBow": 73829,
	"./beta/weapon/42---LongBow.json": 73829,
	"./beta/weapon/43---SonicCrossbow": 1179,
	"./beta/weapon/43---SonicCrossbow.json": 1179,
	"./beta/weapon/44---CloseCombatBow": 55058,
	"./beta/weapon/44---CloseCombatBow.json": 55058,
	"./beta/weapon/45---FastBow": 26512,
	"./beta/weapon/45---FastBow.json": 26512,
	"./beta/weapon/46---FrostBow": 33997,
	"./beta/weapon/46---FrostBow.json": 33997,
	"./beta/weapon/47---CrossBow": 53916,
	"./beta/weapon/47---CrossBow.json": 53916,
	"./beta/weapon/48---CrossBowOffHand": 45277,
	"./beta/weapon/48---CrossBowOffHand.json": 45277,
	"./beta/weapon/49---MultiCrossBow": 28769,
	"./beta/weapon/49---MultiCrossBow.json": 28769,
	"./beta/weapon/50---MultiCrossBowOffHand": 68389,
	"./beta/weapon/50---MultiCrossBowOffHand.json": 68389,
	"./beta/weapon/51---FrostCrossBow": 51837,
	"./beta/weapon/51---FrostCrossBow.json": 51837,
	"./beta/weapon/52---FrostCrossBowOffHand": 49233,
	"./beta/weapon/52---FrostCrossBowOffHand.json": 49233,
	"./beta/weapon/53---ExplosiveCrossBow": 57136,
	"./beta/weapon/53---ExplosiveCrossBow.json": 57136,
	"./beta/weapon/54---ExplosiveCrossBowOffHand": 41190,
	"./beta/weapon/54---ExplosiveCrossBowOffHand.json": 41190,
	"./beta/weapon/55---AlchemicGun": 9564,
	"./beta/weapon/55---AlchemicGun.json": 9564,
	"./beta/weapon/56---MarkBow": 45303,
	"./beta/weapon/56---MarkBow.json": 45303,
	"./beta/weapon/57---PreciseBow": 22476,
	"./beta/weapon/57---PreciseBow.json": 22476,
	"./beta/weapon/58---ThrowingKnife": 11036,
	"./beta/weapon/58---ThrowingKnife.json": 11036,
	"./beta/weapon/59---Boomerang": 8848,
	"./beta/weapon/59---Boomerang.json": 8848,
	"./beta/weapon/60---BleedAxe": 39168,
	"./beta/weapon/60---BleedAxe.json": 39168,
	"./beta/weapon/61---GodAxe": 75551,
	"./beta/weapon/61---GodAxe.json": 75551,
	"./beta/weapon/62---ThrowingSpear": 58381,
	"./beta/weapon/62---ThrowingSpear.json": 58381,
	"./beta/weapon/63---Blowgun": 81124,
	"./beta/weapon/63---Blowgun.json": 81124,
	"./beta/weapon/64---StartShield": 24398,
	"./beta/weapon/64---StartShield.json": 24398,
	"./beta/weapon/65---WarriorShield": 95375,
	"./beta/weapon/65---WarriorShield.json": 95375,
	"./beta/weapon/66---Shield": 42870,
	"./beta/weapon/66---Shield.json": 42870,
	"./beta/weapon/67---AreaShield": 51106,
	"./beta/weapon/67---AreaShield.json": 51106,
	"./beta/weapon/68---BumpShield": 65389,
	"./beta/weapon/68---BumpShield.json": 65389,
	"./beta/weapon/69---Rampart": 66453,
	"./beta/weapon/69---Rampart.json": 66453,
	"./beta/weapon/70---GreedShield": 30846,
	"./beta/weapon/70---GreedShield.json": 30846,
	"./beta/weapon/71---DashShield": 786,
	"./beta/weapon/71---DashShield.json": 786,
	"./beta/weapon/72---BloodShield": 38713,
	"./beta/weapon/72---BloodShield.json": 38713,
	"./beta/weapon/73---SpikeShield": 56336,
	"./beta/weapon/73---SpikeShield.json": 56336,
	"./beta/weapon/74---ParryShield": 56861,
	"./beta/weapon/74---ParryShield.json": 56861,
	"./beta/weapon/75---HoldShield": 62756,
	"./beta/weapon/75---HoldShield.json": 62756,
	"./beta/weapon/76---ThunderShield": 87984,
	"./beta/weapon/76---ThunderShield.json": 87984,
	"./beta/weapon/77---IceShield": 73399,
	"./beta/weapon/77---IceShield.json": 73399,
	"./beta/weapon/78---MagicSalve": 27610,
	"./beta/weapon/78---MagicSalve.json": 27610,
	"./beta/weapon/79---FireBall": 65139,
	"./beta/weapon/79---FireBall.json": 65139,
	"./beta/weapon/80---Lightning": 38402,
	"./beta/weapon/80---Lightning.json": 38402,
	"./beta/weapon/81---LightningWhip": 87487,
	"./beta/weapon/81---LightningWhip.json": 87487,
	"./beta/weapon/82---FlameThrower": 68732,
	"./beta/weapon/82---FlameThrower.json": 68732,
	"./beta/weapon/83---ThrowingTorch": 63787,
	"./beta/weapon/83---ThrowingTorch.json": 63787,
	"./beta/weapon/84---ThrowingIce": 80029,
	"./beta/weapon/84---ThrowingIce.json": 80029,
	"./beta/weapon/85---Freeze": 48547,
	"./beta/weapon/85---Freeze.json": 48547,
	"./beta/weapon/86---BarrelLauncher": 83046,
	"./beta/weapon/86---BarrelLauncher.json": 83046,
	"./beta/weapon/87---Katana": 12465,
	"./beta/weapon/87---Katana.json": 12465,
	"./beta/weapon/__PROPS__": 95826,
	"./beta/weapon/__PROPS__.json": 95826,
	"./beta/weapon/__STRUCTURE__": 6315,
	"./beta/weapon/__STRUCTURE__.json": 6315,
	"./stable/blueprintDrop/0---Always": 69747,
	"./stable/blueprintDrop/0---Always.json": 69747,
	"./stable/blueprintDrop/1---Common": 68737,
	"./stable/blueprintDrop/1---Common.json": 68737,
	"./stable/blueprintDrop/2---Uncommon": 70749,
	"./stable/blueprintDrop/2---Uncommon.json": 70749,
	"./stable/blueprintDrop/3---Rare": 1724,
	"./stable/blueprintDrop/3---Rare.json": 1724,
	"./stable/blueprintDrop/4---Legendary": 24721,
	"./stable/blueprintDrop/4---Legendary.json": 24721,
	"./stable/item/DeployedTrap/000---HorizontalTurret": 96107,
	"./stable/item/DeployedTrap/000---HorizontalTurret.json": 96107,
	"./stable/item/DeployedTrap/001---StandardTurret": 47205,
	"./stable/item/DeployedTrap/001---StandardTurret.json": 47205,
	"./stable/item/DeployedTrap/002---HeavyTurret": 91746,
	"./stable/item/DeployedTrap/002---HeavyTurret.json": 91746,
	"./stable/item/DeployedTrap/003---CeilTurret": 52653,
	"./stable/item/DeployedTrap/003---CeilTurret.json": 52653,
	"./stable/item/DeployedTrap/004---FireTurret": 80999,
	"./stable/item/DeployedTrap/004---FireTurret.json": 80999,
	"./stable/item/DeployedTrap/005---GroundSaw": 8649,
	"./stable/item/DeployedTrap/005---GroundSaw.json": 8649,
	"./stable/item/DeployedTrap/006---RootTrap": 91511,
	"./stable/item/DeployedTrap/006---RootTrap.json": 91511,
	"./stable/item/DeployedTrap/007---Crusher": 9949,
	"./stable/item/DeployedTrap/007---Crusher.json": 9949,
	"./stable/item/DeployedTrap/008---Decoy": 27126,
	"./stable/item/DeployedTrap/008---Decoy.json": 27126,
	"./stable/item/DeployedTrap/009---PortableDoor": 3820,
	"./stable/item/DeployedTrap/009---PortableDoor.json": 3820,
	"./stable/item/DeployedTrap/010---TeslaCoil": 41314,
	"./stable/item/DeployedTrap/010---TeslaCoil.json": 41314,
	"./stable/item/DeployedTrap/011---Cannon": 8769,
	"./stable/item/DeployedTrap/011---Cannon.json": 8769,
	"./stable/item/DeployedTrap/012---DarknessLantern": 29355,
	"./stable/item/DeployedTrap/012---DarknessLantern.json": 29355,
	"./stable/item/Grenade/013---ExplosiveGrenade": 64492,
	"./stable/item/Grenade/013---ExplosiveGrenade.json": 64492,
	"./stable/item/Grenade/014---FastGrenade": 42970,
	"./stable/item/Grenade/014---FastGrenade.json": 42970,
	"./stable/item/Grenade/015---ClusterBomb": 82808,
	"./stable/item/Grenade/015---ClusterBomb.json": 82808,
	"./stable/item/Grenade/016---MagnetGrenade": 80564,
	"./stable/item/Grenade/016---MagnetGrenade.json": 80564,
	"./stable/item/Grenade/017---StunningGrenade": 2291,
	"./stable/item/Grenade/017---StunningGrenade.json": 2291,
	"./stable/item/Grenade/018---IceBomb": 5844,
	"./stable/item/Grenade/018---IceBomb.json": 5844,
	"./stable/item/Grenade/019---FireBomb": 27542,
	"./stable/item/Grenade/019---FireBomb.json": 27542,
	"./stable/item/Grenade/020---RootBomb": 26795,
	"./stable/item/Grenade/020---RootBomb.json": 26795,
	"./stable/item/Grenade/021---OilBomb": 14764,
	"./stable/item/Grenade/021---OilBomb.json": 14764,
	"./stable/item/Grenade/022---SideBomb": 30805,
	"./stable/item/Grenade/022---SideBomb.json": 30805,
	"./stable/item/Grenade/023---Pokebomb": 10896,
	"./stable/item/Grenade/023---Pokebomb.json": 10896,
	"./stable/item/Grenade/024---HolyWater": 18708,
	"./stable/item/Grenade/024---HolyWater.json": 18708,
	"./stable/item/Melee/077---StartSword": 98580,
	"./stable/item/Melee/077---StartSword.json": 98580,
	"./stable/item/Melee/078---AdminWeapon": 22612,
	"./stable/item/Melee/078---AdminWeapon.json": 22612,
	"./stable/item/Melee/079---QuickSword": 5001,
	"./stable/item/Melee/079---QuickSword.json": 5001,
	"./stable/item/Melee/080---RevengeSword": 20599,
	"./stable/item/Melee/080---RevengeSword.json": 20599,
	"./stable/item/Melee/081---BackStabber": 81432,
	"./stable/item/Melee/081---BackStabber.json": 81432,
	"./stable/item/Melee/082---Bleeder": 4209,
	"./stable/item/Melee/082---Bleeder.json": 4209,
	"./stable/item/Melee/083---DualDaggers": 19437,
	"./stable/item/Melee/083---DualDaggers.json": 19437,
	"./stable/item/Melee/084---BroadSword": 23342,
	"./stable/item/Melee/084---BroadSword.json": 23342,
	"./stable/item/Melee/085---Shovel": 75115,
	"./stable/item/Melee/085---Shovel.json": 75115,
	"./stable/item/Melee/086---EvilSword": 27157,
	"./stable/item/Melee/086---EvilSword.json": 27157,
	"./stable/item/Melee/087---BleedCrit": 93644,
	"./stable/item/Melee/087---BleedCrit.json": 93644,
	"./stable/item/Melee/088---SpeedBlade": 17900,
	"./stable/item/Melee/088---SpeedBlade.json": 17900,
	"./stable/item/Melee/089---GiantKiller": 27757,
	"./stable/item/Melee/089---GiantKiller.json": 27757,
	"./stable/item/Melee/090---BulletBlade": 77864,
	"./stable/item/Melee/090---BulletBlade.json": 77864,
	"./stable/item/Melee/091---SismicBlade": 80548,
	"./stable/item/Melee/091---SismicBlade.json": 80548,
	"./stable/item/Melee/092---Spear": 69361,
	"./stable/item/Melee/092---Spear.json": 69361,
	"./stable/item/Melee/093---ImpaleSpear": 70339,
	"./stable/item/Melee/093---ImpaleSpear.json": 70339,
	"./stable/item/Melee/094---KingsSpear": 98754,
	"./stable/item/Melee/094---KingsSpear.json": 98754,
	"./stable/item/Melee/095---Rapier": 51616,
	"./stable/item/Melee/095---Rapier.json": 51616,
	"./stable/item/Melee/096---DashSword": 40932,
	"./stable/item/Melee/096---DashSword.json": 40932,
	"./stable/item/Melee/097---StunMace": 65045,
	"./stable/item/Melee/097---StunMace.json": 65045,
	"./stable/item/Melee/098---BumpBoots": 58308,
	"./stable/item/Melee/098---BumpBoots.json": 58308,
	"./stable/item/Melee/099---SpikedBoots": 17391,
	"./stable/item/Melee/099---SpikedBoots.json": 17391,
	"./stable/item/Melee/100---MultiKickBoots": 34854,
	"./stable/item/Melee/100---MultiKickBoots.json": 34854,
	"./stable/item/Melee/101---QuickFists": 44550,
	"./stable/item/Melee/101---QuickFists.json": 44550,
	"./stable/item/Melee/102---Whip": 38163,
	"./stable/item/Melee/102---Whip.json": 38163,
	"./stable/item/Melee/103---HookWhip": 36767,
	"./stable/item/Melee/103---HookWhip.json": 36767,
	"./stable/item/Melee/104---OilSword": 71267,
	"./stable/item/Melee/104---OilSword.json": 71267,
	"./stable/item/Melee/105---Burner": 30225,
	"./stable/item/Melee/105---Burner.json": 30225,
	"./stable/item/Melee/106---LowHealth": 16715,
	"./stable/item/Melee/106---LowHealth.json": 16715,
	"./stable/item/Melee/107---PerfectHalberd": 74768,
	"./stable/item/Melee/107---PerfectHalberd.json": 74768,
	"./stable/item/Melee/108---BehemothHammer": 29335,
	"./stable/item/Melee/108---BehemothHammer.json": 29335,
	"./stable/item/Melee/109---TentacleWhip": 95098,
	"./stable/item/Melee/109---TentacleWhip.json": 95098,
	"./stable/item/Melee/110---Pan": 72198,
	"./stable/item/Melee/110---Pan.json": 72198,
	"./stable/item/Melee/111---ParryBlade": 75840,
	"./stable/item/Melee/111---ParryBlade.json": 75840,
	"./stable/item/Melee/112---TickScytheLeft": 97199,
	"./stable/item/Melee/112---TickScytheLeft.json": 97199,
	"./stable/item/Melee/113---TickScytheRight": 8642,
	"./stable/item/Melee/113---TickScytheRight.json": 8642,
	"./stable/item/Melee/114---RhythmicBlade": 12703,
	"./stable/item/Melee/114---RhythmicBlade.json": 12703,
	"./stable/item/Melee/115---Crowbar": 80717,
	"./stable/item/Melee/115---Crowbar.json": 80717,
	"./stable/item/Melee/116---SnakeFang": 89353,
	"./stable/item/Melee/116---SnakeFang.json": 89353,
	"./stable/item/Melee/117---GiantStaff": 1157,
	"./stable/item/Melee/117---GiantStaff.json": 1157,
	"./stable/item/Melee/118---Lantern": 64654,
	"./stable/item/Melee/118---Lantern.json": 64654,
	"./stable/item/Melee/119---NotFlyingSword": 73465,
	"./stable/item/Melee/119---NotFlyingSword.json": 73465,
	"./stable/item/Melee/120---Katana": 97971,
	"./stable/item/Melee/120---Katana.json": 97971,
	"./stable/item/Melee/121---ExplosiveCrossBowOffHand": 70054,
	"./stable/item/Melee/121---ExplosiveCrossBowOffHand.json": 70054,
	"./stable/item/Melee/122---Tombstone": 59,
	"./stable/item/Melee/122---Tombstone.json": 59,
	"./stable/item/Melee/123---HeavyAxe": 43139,
	"./stable/item/Melee/123---HeavyAxe.json": 43139,
	"./stable/item/Melee/124---Club": 65889,
	"./stable/item/Melee/124---Club.json": 65889,
	"./stable/item/Melee/125---ClubBroken": 26162,
	"./stable/item/Melee/125---ClubBroken.json": 26162,
	"./stable/item/Melee/126---MachetePistol": 82298,
	"./stable/item/Melee/126---MachetePistol.json": 82298,
	"./stable/item/Melee/127---HardLightSword": 80308,
	"./stable/item/Melee/127---HardLightSword.json": 80308,
	"./stable/item/Melee/128---PureNail": 30606,
	"./stable/item/Melee/128---PureNail.json": 30606,
	"./stable/item/Melee/129---SkulBone": 63752,
	"./stable/item/Melee/129---SkulBone.json": 63752,
	"./stable/item/Melee/130---Trident": 83356,
	"./stable/item/Melee/130---Trident.json": 83356,
	"./stable/item/Melee/131---HandHook": 52702,
	"./stable/item/Melee/131---HandHook.json": 52702,
	"./stable/item/Melee/132---Shark": 62436,
	"./stable/item/Melee/132---Shark.json": 62436,
	"./stable/item/Melee/133---ElbowBlades": 46352,
	"./stable/item/Melee/133---ElbowBlades.json": 46352,
	"./stable/item/Melee/134---WreckingBall": 71442,
	"./stable/item/Melee/134---WreckingBall.json": 71442,
	"./stable/item/Melee/135---QueenRapier": 97724,
	"./stable/item/Melee/135---QueenRapier.json": 97724,
	"./stable/item/Melee/136---CupidityDagger": 71261,
	"./stable/item/Melee/136---CupidityDagger.json": 71261,
	"./stable/item/Melee/137---GoldDigger": 84443,
	"./stable/item/Melee/137---GoldDigger.json": 84443,
	"./stable/item/Melee/138---GoldDiggerEvolved": 67747,
	"./stable/item/Melee/138---GoldDiggerEvolved.json": 67747,
	"./stable/item/Melee/139---KingScepter": 67489,
	"./stable/item/Melee/139---KingScepter.json": 67489,
	"./stable/item/Melee/140---BaseballBat": 80973,
	"./stable/item/Melee/140---BaseballBat.json": 80973,
	"./stable/item/Melee/141---NunchuckPan": 85904,
	"./stable/item/Melee/141---NunchuckPan.json": 85904,
	"./stable/item/Melee/142---Starfury": 54440,
	"./stable/item/Melee/142---Starfury.json": 54440,
	"./stable/item/Melee/143---TPSword": 58845,
	"./stable/item/Melee/143---TPSword.json": 58845,
	"./stable/item/Melee/144---WiggleWhip": 2260,
	"./stable/item/Melee/144---WiggleWhip.json": 2260,
	"./stable/item/Melee/145---Bible": 719,
	"./stable/item/Melee/145---Bible.json": 719,
	"./stable/item/Melee/146---SnakeSwordWeapon": 39746,
	"./stable/item/Melee/146---SnakeSwordWeapon.json": 39746,
	"./stable/item/Melee/147---SnakeSwordWeaponAlt": 44449,
	"./stable/item/Melee/147---SnakeSwordWeaponAlt.json": 44449,
	"./stable/item/Melee/148---SnakeSwordSwap": 35286,
	"./stable/item/Melee/148---SnakeSwordSwap.json": 35286,
	"./stable/item/Melee/149---VampireKiller": 92470,
	"./stable/item/Melee/149---VampireKiller.json": 92470,
	"./stable/item/Melee/150---AdeleScythe": 78434,
	"./stable/item/Melee/150---AdeleScythe.json": 78434,
	"./stable/item/Melee/151---RichterVampireKiller": 87085,
	"./stable/item/Melee/151---RichterVampireKiller.json": 87085,
	"./stable/item/Melee/152---CombinedTickScythe": 72581,
	"./stable/item/Melee/152---CombinedTickScythe.json": 72581,
	"./stable/item/Melee/153---Pistol": 58991,
	"./stable/item/Melee/153---Pistol.json": 58991,
	"./stable/item/Melee/154---Scissor": 47289,
	"./stable/item/Melee/154---Scissor.json": 47289,
	"./stable/item/Melee/155---Comb": 59747,
	"./stable/item/Melee/155---Comb.json": 59747,
	"./stable/item/Power/026---SlowOrb": 25223,
	"./stable/item/Power/026---SlowOrb.json": 25223,
	"./stable/item/Power/027---Tornado": 15005,
	"./stable/item/Power/027---Tornado.json": 15005,
	"./stable/item/Power/028---KnivesCircle": 57013,
	"./stable/item/Power/028---KnivesCircle.json": 57013,
	"./stable/item/Power/029---DamageBuff": 94137,
	"./stable/item/Power/029---DamageBuff.json": 94137,
	"./stable/item/Power/030---LeechBuff": 68870,
	"./stable/item/Power/030---LeechBuff.json": 68870,
	"./stable/item/Power/031---ExtraHeal": 79801,
	"./stable/item/Power/031---ExtraHeal.json": 79801,
	"./stable/item/Power/032---BulletKiller": 16550,
	"./stable/item/Power/032---BulletKiller.json": 16550,
	"./stable/item/Power/033---Hook": 69978,
	"./stable/item/Power/033---Hook.json": 69978,
	"./stable/item/Power/034---BackBlink": 76698,
	"./stable/item/Power/034---BackBlink.json": 76698,
	"./stable/item/Power/035---TimeDistorsion": 61496,
	"./stable/item/Power/035---TimeDistorsion.json": 61496,
	"./stable/item/Power/036---ToxicCloud": 89780,
	"./stable/item/Power/036---ToxicCloud.json": 89780,
	"./stable/item/Power/037---DamageAura": 84334,
	"./stable/item/Power/037---DamageAura.json": 84334,
	"./stable/item/Power/038---Shockwave": 61019,
	"./stable/item/Power/038---Shockwave.json": 61019,
	"./stable/item/Power/039---Wings": 11942,
	"./stable/item/Power/039---Wings.json": 11942,
	"./stable/item/Power/040---ComboMult": 16914,
	"./stable/item/Power/040---ComboMult.json": 16914,
	"./stable/item/Power/041---Pokecharge": 87174,
	"./stable/item/Power/041---Pokecharge.json": 87174,
	"./stable/item/Power/042---Map": 22793,
	"./stable/item/Power/042---Map.json": 22793,
	"./stable/item/Power/043---Owl": 82793,
	"./stable/item/Power/043---Owl.json": 82793,
	"./stable/item/Power/044---OwlUp": 59830,
	"./stable/item/Power/044---OwlUp.json": 59830,
	"./stable/item/Power/045---Chicken": 79637,
	"./stable/item/Power/045---Chicken.json": 79637,
	"./stable/item/Power/046---SpeedRunner": 9348,
	"./stable/item/Power/046---SpeedRunner.json": 9348,
	"./stable/item/Power/047---Dash": 14661,
	"./stable/item/Power/047---Dash.json": 14661,
	"./stable/item/Power/048---BackDash": 76534,
	"./stable/item/Power/048---BackDash.json": 76534,
	"./stable/item/Power/049---GiantWhistle": 38970,
	"./stable/item/Power/049---GiantWhistle.json": 38970,
	"./stable/item/Power/050---SeismicStomp": 50397,
	"./stable/item/Power/050---SeismicStomp.json": 50397,
	"./stable/item/Power/051---CollectorSpin": 82079,
	"./stable/item/Power/051---CollectorSpin.json": 82079,
	"./stable/item/Power/052---SmokeBomb": 14112,
	"./stable/item/Power/052---SmokeBomb.json": 14112,
	"./stable/item/Power/053---SpawnFriendlyHardy": 13776,
	"./stable/item/Power/053---SpawnFriendlyHardy.json": 13776,
	"./stable/item/Power/054---ExplodeFriendlyHardy": 53653,
	"./stable/item/Power/054---ExplodeFriendlyHardy.json": 53653,
	"./stable/item/Power/055---IceArmor": 36,
	"./stable/item/Power/055---IceArmor.json": 36,
	"./stable/item/Power/056---LightningRod": 55759,
	"./stable/item/Power/056---LightningRod.json": 55759,
	"./stable/item/Power/057---GardenerSickles": 26098,
	"./stable/item/Power/057---GardenerSickles.json": 26098,
	"./stable/item/Power/058---FlyingSword": 61961,
	"./stable/item/Power/058---FlyingSword.json": 61961,
	"./stable/item/Power/059---FlyingSwordCallback": 26746,
	"./stable/item/Power/059---FlyingSwordCallback.json": 26746,
	"./stable/item/Power/060---BubbleShieldPower": 35819,
	"./stable/item/Power/060---BubbleShieldPower.json": 35819,
	"./stable/item/Power/061---FaceFlask": 67755,
	"./stable/item/Power/061---FaceFlask.json": 67755,
	"./stable/item/Power/062---PolloPower": 42759,
	"./stable/item/Power/062---PolloPower.json": 42759,
	"./stable/item/Power/063---SpawnLilStaphy": 14235,
	"./stable/item/Power/063---SpawnLilStaphy.json": 14235,
	"./stable/item/Power/064---LilStaphyStab": 17485,
	"./stable/item/Power/064---LilStaphyStab.json": 17485,
	"./stable/item/Power/065---SpawnAdultLilStaphy": 98459,
	"./stable/item/Power/065---SpawnAdultLilStaphy.json": 98459,
	"./stable/item/Power/066---AdultLilStaphyStab": 89208,
	"./stable/item/Power/066---AdultLilStaphyStab.json": 89208,
	"./stable/item/Power/067---DiverseDeckJuggernaut": 43071,
	"./stable/item/Power/067---DiverseDeckJuggernaut.json": 43071,
	"./stable/item/Power/068---DiverseDeckCatalyst": 49298,
	"./stable/item/Power/068---DiverseDeckCatalyst.json": 49298,
	"./stable/item/Power/069---DiverseDeckElectro": 79553,
	"./stable/item/Power/069---DiverseDeckElectro.json": 79553,
	"./stable/item/Power/070---DiverseDeckWatcher": 73741,
	"./stable/item/Power/070---DiverseDeckWatcher.json": 73741,
	"./stable/item/Power/071---Taunt": 51708,
	"./stable/item/Power/071---Taunt.json": 51708,
	"./stable/item/Power/072---BouncingStone": 60162,
	"./stable/item/Power/072---BouncingStone.json": 60162,
	"./stable/item/Power/073---SpawnCat": 90573,
	"./stable/item/Power/073---SpawnCat.json": 90573,
	"./stable/item/Power/074---CatAttack": 13157,
	"./stable/item/Power/074---CatAttack.json": 13157,
	"./stable/item/Power/075---BatVolley": 64577,
	"./stable/item/Power/075---BatVolley.json": 64577,
	"./stable/item/Power/076---RichterCross": 52215,
	"./stable/item/Power/076---RichterCross.json": 52215,
	"./stable/item/Ranged/156---StartBow": 83941,
	"./stable/item/Ranged/156---StartBow.json": 83941,
	"./stable/item/Ranged/157---DualBow": 11310,
	"./stable/item/Ranged/157---DualBow.json": 11310,
	"./stable/item/Ranged/158---InfiniteBow": 50326,
	"./stable/item/Ranged/158---InfiniteBow.json": 50326,
	"./stable/item/Ranged/159---LongBow": 87966,
	"./stable/item/Ranged/159---LongBow.json": 87966,
	"./stable/item/Ranged/160---SonicCrossbow": 42166,
	"./stable/item/Ranged/160---SonicCrossbow.json": 42166,
	"./stable/item/Ranged/161---CloseCombatBow": 67269,
	"./stable/item/Ranged/161---CloseCombatBow.json": 67269,
	"./stable/item/Ranged/162---FastBow": 99302,
	"./stable/item/Ranged/162---FastBow.json": 99302,
	"./stable/item/Ranged/163---FrostBow": 7996,
	"./stable/item/Ranged/163---FrostBow.json": 7996,
	"./stable/item/Ranged/164---CrossBow": 50143,
	"./stable/item/Ranged/164---CrossBow.json": 50143,
	"./stable/item/Ranged/165---CrossBowOffHand": 95171,
	"./stable/item/Ranged/165---CrossBowOffHand.json": 95171,
	"./stable/item/Ranged/166---MultiCrossBow": 71960,
	"./stable/item/Ranged/166---MultiCrossBow.json": 71960,
	"./stable/item/Ranged/167---MultiCrossBowOffHand": 73500,
	"./stable/item/Ranged/167---MultiCrossBowOffHand.json": 73500,
	"./stable/item/Ranged/168---FrostCrossBow": 2246,
	"./stable/item/Ranged/168---FrostCrossBow.json": 2246,
	"./stable/item/Ranged/169---FrostCrossBowOffHand": 15119,
	"./stable/item/Ranged/169---FrostCrossBowOffHand.json": 15119,
	"./stable/item/Ranged/170---ExplosiveCrossBow": 14974,
	"./stable/item/Ranged/170---ExplosiveCrossBow.json": 14974,
	"./stable/item/Ranged/171---AlchemicGun": 77561,
	"./stable/item/Ranged/171---AlchemicGun.json": 77561,
	"./stable/item/Ranged/172---Boomerang": 56177,
	"./stable/item/Ranged/172---Boomerang.json": 56177,
	"./stable/item/Ranged/173---BleedAxe": 2162,
	"./stable/item/Ranged/173---BleedAxe.json": 2162,
	"./stable/item/Ranged/174---GodAxe": 93748,
	"./stable/item/Ranged/174---GodAxe.json": 93748,
	"./stable/item/Ranged/175---ThrowingSpear": 39607,
	"./stable/item/Ranged/175---ThrowingSpear.json": 39607,
	"./stable/item/Ranged/176---MarkBow": 99105,
	"./stable/item/Ranged/176---MarkBow.json": 99105,
	"./stable/item/Ranged/177---PreciseBow": 17717,
	"./stable/item/Ranged/177---PreciseBow.json": 17717,
	"./stable/item/Ranged/178---ThrowingKnife": 35121,
	"./stable/item/Ranged/178---ThrowingKnife.json": 35121,
	"./stable/item/Ranged/179---LightningWhip": 13886,
	"./stable/item/Ranged/179---LightningWhip.json": 13886,
	"./stable/item/Ranged/180---ThrowingTorch": 24440,
	"./stable/item/Ranged/180---ThrowingTorch.json": 24440,
	"./stable/item/Ranged/181---ThrowingIce": 23670,
	"./stable/item/Ranged/181---ThrowingIce.json": 23670,
	"./stable/item/Ranged/182---FireBall": 57209,
	"./stable/item/Ranged/182---FireBall.json": 57209,
	"./stable/item/Ranged/183---Lightning": 48893,
	"./stable/item/Ranged/183---Lightning.json": 48893,
	"./stable/item/Ranged/184---FlameThrower": 60394,
	"./stable/item/Ranged/184---FlameThrower.json": 60394,
	"./stable/item/Ranged/185---Freeze": 95178,
	"./stable/item/Ranged/185---Freeze.json": 95178,
	"./stable/item/Ranged/186---MagicSalve": 28273,
	"./stable/item/Ranged/186---MagicSalve.json": 28273,
	"./stable/item/Ranged/187---Blowgun": 94359,
	"./stable/item/Ranged/187---Blowgun.json": 94359,
	"./stable/item/Ranged/188---BarrelLauncher": 30163,
	"./stable/item/Ranged/188---BarrelLauncher.json": 30163,
	"./stable/item/Ranged/189---LanternOffHand": 20366,
	"./stable/item/Ranged/189---LanternOffHand.json": 20366,
	"./stable/item/Ranged/190---HardLightGun": 4885,
	"./stable/item/Ranged/190---HardLightGun.json": 4885,
	"./stable/item/Ranged/191---ThrowingCards": 6393,
	"./stable/item/Ranged/191---ThrowingCards.json": 6393,
	"./stable/item/Ranged/192---HeavyBow": 97612,
	"./stable/item/Ranged/192---HeavyBow.json": 97612,
	"./stable/item/Ranged/193---MoneyShooter": 24878,
	"./stable/item/Ranged/193---MoneyShooter.json": 24878,
	"./stable/item/Ranged/194---MagicBow": 99082,
	"./stable/item/Ranged/194---MagicBow.json": 99082,
	"./stable/item/Ranged/195---ThrowableStuff": 97119,
	"./stable/item/Ranged/195---ThrowableStuff.json": 97119,
	"./stable/item/Ranged/196---LaserGlaive": 42280,
	"./stable/item/Ranged/196---LaserGlaive.json": 42280,
	"./stable/item/Ranged/197---HydraSpell": 94363,
	"./stable/item/Ranged/197---HydraSpell.json": 94363,
	"./stable/item/Ranged/198---Cross": 26965,
	"./stable/item/Ranged/198---Cross.json": 26965,
	"./stable/item/Ranged/199---ThrowingAxe": 27209,
	"./stable/item/Ranged/199---ThrowingAxe.json": 27209,
	"./stable/item/Ranged/200---MedusaHead": 89754,
	"./stable/item/Ranged/200---MedusaHead.json": 89754,
	"./stable/item/Shield/201---StartShield": 30133,
	"./stable/item/Shield/201---StartShield.json": 30133,
	"./stable/item/Shield/202---WarriorShield": 64789,
	"./stable/item/Shield/202---WarriorShield.json": 64789,
	"./stable/item/Shield/203---Shield": 35764,
	"./stable/item/Shield/203---Shield.json": 35764,
	"./stable/item/Shield/204---AreaShield": 62704,
	"./stable/item/Shield/204---AreaShield.json": 62704,
	"./stable/item/Shield/205---BumpShield": 38925,
	"./stable/item/Shield/205---BumpShield.json": 38925,
	"./stable/item/Shield/206---Rampart": 44527,
	"./stable/item/Shield/206---Rampart.json": 44527,
	"./stable/item/Shield/207---DashShield": 28794,
	"./stable/item/Shield/207---DashShield.json": 28794,
	"./stable/item/Shield/208---BloodShield": 90442,
	"./stable/item/Shield/208---BloodShield.json": 90442,
	"./stable/item/Shield/209---GreedShield": 664,
	"./stable/item/Shield/209---GreedShield.json": 664,
	"./stable/item/Shield/210---SpikeShield": 78221,
	"./stable/item/Shield/210---SpikeShield.json": 78221,
	"./stable/item/Shield/211---ParryShield": 2558,
	"./stable/item/Shield/211---ParryShield.json": 2558,
	"./stable/item/Shield/212---HoldShield": 70200,
	"./stable/item/Shield/212---HoldShield.json": 70200,
	"./stable/item/Shield/213---ThunderShield": 64744,
	"./stable/item/Shield/213---ThunderShield.json": 64744,
	"./stable/item/Shield/214---IceShield": 59496,
	"./stable/item/Shield/214---IceShield.json": 59496,
	"./stable/item/Shield/215---AlucardShield": 12187,
	"./stable/item/Shield/215---AlucardShield.json": 12187,
	"./stable/level/000---PrisonStart": 36098,
	"./stable/level/000---PrisonStart.json": 36098,
	"./stable/level/001---PrisonCourtyard": 52643,
	"./stable/level/001---PrisonCourtyard.json": 52643,
	"./stable/level/002---SewerShort": 15406,
	"./stable/level/002---SewerShort.json": 15406,
	"./stable/level/003---PrisonDepths": 37895,
	"./stable/level/003---PrisonDepths.json": 37895,
	"./stable/level/004---PrisonCorrupt": 20954,
	"./stable/level/004---PrisonCorrupt.json": 20954,
	"./stable/level/005---PrisonRoof": 97809,
	"./stable/level/005---PrisonRoof.json": 97809,
	"./stable/level/006---Ossuary": 30603,
	"./stable/level/006---Ossuary.json": 30603,
	"./stable/level/007---SewerDepths": 81631,
	"./stable/level/007---SewerDepths.json": 81631,
	"./stable/level/008---Bridge": 55473,
	"./stable/level/008---Bridge.json": 55473,
	"./stable/level/009---BeholderPit": 82604,
	"./stable/level/009---BeholderPit.json": 82604,
	"./stable/level/010---StiltVillage": 34682,
	"./stable/level/010---StiltVillage.json": 34682,
	"./stable/level/011---AncientTemple": 81713,
	"./stable/level/011---AncientTemple.json": 81713,
	"./stable/level/012---Cemetery": 38932,
	"./stable/level/012---Cemetery.json": 38932,
	"./stable/level/013---ClockTower": 95489,
	"./stable/level/013---ClockTower.json": 95489,
	"./stable/level/014---Crypt": 46431,
	"./stable/level/014---Crypt.json": 46431,
	"./stable/level/015---TopClockTower": 33923,
	"./stable/level/015---TopClockTower.json": 33923,
	"./stable/level/016---Cavern": 94992,
	"./stable/level/016---Cavern.json": 94992,
	"./stable/level/017---Giant": 32522,
	"./stable/level/017---Giant.json": 32522,
	"./stable/level/018---Castle": 10265,
	"./stable/level/018---Castle.json": 10265,
	"./stable/level/019---Distillery": 17173,
	"./stable/level/019---Distillery.json": 17173,
	"./stable/level/020---Throne": 93186,
	"./stable/level/020---Throne.json": 93186,
	"./stable/level/021---Astrolab": 87900,
	"./stable/level/021---Astrolab.json": 87900,
	"./stable/level/022---Observatory": 78785,
	"./stable/level/022---Observatory.json": 78785,
	"./stable/level/023---IllegalLevel": 46126,
	"./stable/level/023---IllegalLevel.json": 46126,
	"./stable/level/024---BoatDock": 69073,
	"./stable/level/024---BoatDock.json": 69073,
	"./stable/level/025---Greenhouse": 36780,
	"./stable/level/025---Greenhouse.json": 36780,
	"./stable/level/026---Swamp": 58333,
	"./stable/level/026---Swamp.json": 58333,
	"./stable/level/027---SwampHeart": 21218,
	"./stable/level/027---SwampHeart.json": 21218,
	"./stable/level/028---Tumulus": 92869,
	"./stable/level/028---Tumulus.json": 92869,
	"./stable/level/029---Cliff": 94791,
	"./stable/level/029---Cliff.json": 94791,
	"./stable/level/030---GardenerStage": 44246,
	"./stable/level/030---GardenerStage.json": 44246,
	"./stable/level/031---Shipwreck": 68453,
	"./stable/level/031---Shipwreck.json": 68453,
	"./stable/level/032---Lighthouse": 18206,
	"./stable/level/032---Lighthouse.json": 18206,
	"./stable/level/033---QueenArena": 90387,
	"./stable/level/033---QueenArena.json": 90387,
	"./stable/level/034---Bank": 6306,
	"./stable/level/034---Bank.json": 6306,
	"./stable/level/035---PurpleGarden": 27321,
	"./stable/level/035---PurpleGarden.json": 27321,
	"./stable/level/036---DookuCastle": 61778,
	"./stable/level/036---DookuCastle.json": 61778,
	"./stable/level/037---DookuCastleHard": 39680,
	"./stable/level/037---DookuCastleHard.json": 39680,
	"./stable/level/038---DeathArena": 33021,
	"./stable/level/038---DeathArena.json": 33021,
	"./stable/level/039---DookuArena": 72153,
	"./stable/level/039---DookuArena.json": 72153,
	"./stable/mob/Boss/094---Behemoth": 48996,
	"./stable/mob/Boss/094---Behemoth.json": 48996,
	"./stable/mob/Boss/095---Beholder": 83138,
	"./stable/mob/Boss/095---Beholder.json": 83138,
	"./stable/mob/Boss/096---BeholderTtcl": 88820,
	"./stable/mob/Boss/096---BeholderTtcl.json": 88820,
	"./stable/mob/Boss/097---MamaTick": 12482,
	"./stable/mob/Boss/097---MamaTick.json": 12482,
	"./stable/mob/Boss/098---TimeKeeper": 54307,
	"./stable/mob/Boss/098---TimeKeeper.json": 54307,
	"./stable/mob/Boss/099---KingsHand": 95132,
	"./stable/mob/Boss/099---KingsHand.json": 95132,
	"./stable/mob/Boss/100---Giant": 51521,
	"./stable/mob/Boss/100---Giant.json": 51521,
	"./stable/mob/Boss/101---GiantEye": 24078,
	"./stable/mob/Boss/101---GiantEye.json": 24078,
	"./stable/mob/Boss/102---GiantHand": 10923,
	"./stable/mob/Boss/102---GiantHand.json": 10923,
	"./stable/mob/Boss/103---Collector": 80495,
	"./stable/mob/Boss/103---Collector.json": 80495,
	"./stable/mob/Boss/104---GardenerBoss": 21126,
	"./stable/mob/Boss/104---GardenerBoss.json": 21126,
	"./stable/mob/Boss/105---AmazonSurvival": 10735,
	"./stable/mob/Boss/105---AmazonSurvival.json": 10735,
	"./stable/mob/Boss/106---AmazonTactic": 78843,
	"./stable/mob/Boss/106---AmazonTactic.json": 78843,
	"./stable/mob/Boss/107---AmazonBrutal": 8231,
	"./stable/mob/Boss/107---AmazonBrutal.json": 8231,
	"./stable/mob/Boss/108---Queen": 863,
	"./stable/mob/Boss/108---Queen.json": 863,
	"./stable/mob/Boss/109---Death": 53063,
	"./stable/mob/Boss/109---Death.json": 53063,
	"./stable/mob/Boss/110---Dooku": 24576,
	"./stable/mob/Boss/110---Dooku.json": 24576,
	"./stable/mob/Boss/111---DookuBeast": 17930,
	"./stable/mob/Boss/111---DookuBeast.json": 17930,
	"./stable/mob/Flying/070---BatDasher": 22667,
	"./stable/mob/Flying/070---BatDasher.json": 22667,
	"./stable/mob/Flying/071---BatKamikaze": 18488,
	"./stable/mob/Flying/071---BatKamikaze.json": 18488,
	"./stable/mob/Flying/072---GoldenBatKamikaze": 43439,
	"./stable/mob/Flying/072---GoldenBatKamikaze.json": 43439,
	"./stable/mob/Flying/073---Fly": 68848,
	"./stable/mob/Flying/073---Fly.json": 68848,
	"./stable/mob/Flying/074---S_Fly": 60302,
	"./stable/mob/Flying/074---S_Fly.json": 60302,
	"./stable/mob/Flying/075---S_ZombieFly": 79328,
	"./stable/mob/Flying/075---S_ZombieFly.json": 79328,
	"./stable/mob/Flying/076---Skull": 6489,
	"./stable/mob/Flying/076---Skull.json": 6489,
	"./stable/mob/Flying/077---Demon": 63866,
	"./stable/mob/Flying/077---Demon.json": 63866,
	"./stable/mob/Flying/078---Librarian": 16700,
	"./stable/mob/Flying/078---Librarian.json": 16700,
	"./stable/mob/Flying/079---FlyingCrow": 20176,
	"./stable/mob/Flying/079---FlyingCrow.json": 20176,
	"./stable/mob/Flying/080---BatDasherPurple": 1085,
	"./stable/mob/Flying/080---BatDasherPurple.json": 1085,
	"./stable/mob/Flying/081---Harpy": 50205,
	"./stable/mob/Flying/081---Harpy.json": 50205,
	"./stable/mob/Melee/000---Zombie": 60997,
	"./stable/mob/Melee/000---Zombie.json": 60997,
	"./stable/mob/Melee/001---FlyZombie": 14689,
	"./stable/mob/Melee/001---FlyZombie.json": 14689,
	"./stable/mob/Melee/002---WormZombie": 48646,
	"./stable/mob/Melee/002---WormZombie.json": 48646,
	"./stable/mob/Melee/003---Worm": 27838,
	"./stable/mob/Melee/003---Worm.json": 27838,
	"./stable/mob/Melee/004---S_Worm": 94458,
	"./stable/mob/Melee/004---S_Worm.json": 94458,
	"./stable/mob/Melee/005---S_WallEggWorm": 59000,
	"./stable/mob/Melee/005---S_WallEggWorm.json": 59000,
	"./stable/mob/Melee/006---Ninja": 87187,
	"./stable/mob/Melee/006---Ninja.json": 87187,
	"./stable/mob/Melee/007---Runner": 56762,
	"./stable/mob/Melee/007---Runner.json": 56762,
	"./stable/mob/Melee/008---LeapingDuelyst": 85327,
	"./stable/mob/Melee/008---LeapingDuelyst.json": 85327,
	"./stable/mob/Melee/009---Shield": 81483,
	"./stable/mob/Melee/009---Shield.json": 81483,
	"./stable/mob/Melee/010---SpikedSatyr": 88831,
	"./stable/mob/Melee/010---SpikedSatyr.json": 88831,
	"./stable/mob/Melee/011---Comboter": 42065,
	"./stable/mob/Melee/011---Comboter.json": 42065,
	"./stable/mob/Melee/012---Hooker": 55925,
	"./stable/mob/Melee/012---Hooker.json": 55925,
	"./stable/mob/Melee/013---Spinner": 7406,
	"./stable/mob/Melee/013---Spinner.json": 7406,
	"./stable/mob/Melee/014---Shocker": 37429,
	"./stable/mob/Melee/014---Shocker.json": 37429,
	"./stable/mob/Melee/015---Golem": 77423,
	"./stable/mob/Melee/015---Golem.json": 77423,
	"./stable/mob/Melee/016---CastleKnight": 52036,
	"./stable/mob/Melee/016---CastleKnight.json": 52036,
	"./stable/mob/Melee/017---Lancer": 26590,
	"./stable/mob/Melee/017---Lancer.json": 26590,
	"./stable/mob/Melee/018---AggressiveZombie": 95267,
	"./stable/mob/Melee/018---AggressiveZombie.json": 95267,
	"./stable/mob/Melee/019---Bomber": 17893,
	"./stable/mob/Melee/019---Bomber.json": 17893,
	"./stable/mob/Melee/020---Earthquaker": 62669,
	"./stable/mob/Melee/020---Earthquaker.json": 62669,
	"./stable/mob/Melee/021---Stomper": 1141,
	"./stable/mob/Melee/021---Stomper.json": 1141,
	"./stable/mob/Melee/022---KingsFinger": 26645,
	"./stable/mob/Melee/022---KingsFinger.json": 26645,
	"./stable/mob/Melee/023---TimeKeeperBot": 8661,
	"./stable/mob/Melee/023---TimeKeeperBot.json": 8661,
	"./stable/mob/Melee/024---StompSkeleton": 11047,
	"./stable/mob/Melee/024---StompSkeleton.json": 11047,
	"./stable/mob/Melee/025---Rampager": 51728,
	"./stable/mob/Melee/025---Rampager.json": 51728,
	"./stable/mob/Melee/026---SewerTtcl": 56576,
	"./stable/mob/Melee/026---SewerTtcl.json": 56576,
	"./stable/mob/Melee/027---ThrowableMushroom": 57223,
	"./stable/mob/Melee/027---ThrowableMushroom.json": 57223,
	"./stable/mob/Melee/028---Fugitive": 69028,
	"./stable/mob/Melee/028---Fugitive.json": 69028,
	"./stable/mob/Melee/029---Blobby": 19030,
	"./stable/mob/Melee/029---Blobby.json": 19030,
	"./stable/mob/Melee/030---Enforcer": 43352,
	"./stable/mob/Melee/030---Enforcer.json": 43352,
	"./stable/mob/Melee/031---Duelist": 8027,
	"./stable/mob/Melee/031---Duelist.json": 8027,
	"./stable/mob/Melee/032---Samurai": 11353,
	"./stable/mob/Melee/032---Samurai.json": 11353,
	"./stable/mob/Melee/033---FatZombie": 10211,
	"./stable/mob/Melee/033---FatZombie.json": 10211,
	"./stable/mob/Melee/034---Rat": 80511,
	"./stable/mob/Melee/034---Rat.json": 80511,
	"./stable/mob/Melee/035---Mimic": 39002,
	"./stable/mob/Melee/035---Mimic.json": 39002,
	"./stable/mob/Melee/036---JavelinSnake": 31381,
	"./stable/mob/Melee/036---JavelinSnake.json": 31381,
	"./stable/mob/Melee/037---BootlegSwordsman": 46106,
	"./stable/mob/Melee/037---BootlegSwordsman.json": 46106,
	"./stable/mob/Melee/038---BootlegShovelman": 38225,
	"./stable/mob/Melee/038---BootlegShovelman.json": 38225,
	"./stable/mob/Melee/039---BoilerRoom": 1636,
	"./stable/mob/Melee/039---BoilerRoom.json": 1636,
	"./stable/mob/Melee/040---U28_Steal": 36019,
	"./stable/mob/Melee/040---U28_Steal.json": 36019,
	"./stable/mob/Melee/041---U28_VacuumCleaner": 83428,
	"./stable/mob/Melee/041---U28_VacuumCleaner.json": 83428,
	"./stable/mob/Melee/042---HauntedArmor": 29074,
	"./stable/mob/Melee/042---HauntedArmor.json": 29074,
	"./stable/mob/Melee/043---Buer": 74269,
	"./stable/mob/Melee/043---Buer.json": 74269,
	"./stable/mob/Melee/044---Werewolf": 63069,
	"./stable/mob/Melee/044---Werewolf.json": 63069,
	"./stable/mob/Melee/045---MiniWerewolf": 41495,
	"./stable/mob/Melee/045---MiniWerewolf.json": 41495,
	"./stable/mob/Melee/046---LancerPurple": 80226,
	"./stable/mob/Melee/046---LancerPurple.json": 80226,
	"./stable/mob/MiniBoss/090---Tick": 84463,
	"./stable/mob/MiniBoss/090---Tick.json": 84463,
	"./stable/mob/MiniBoss/091---AxeStatue": 78757,
	"./stable/mob/MiniBoss/091---AxeStatue.json": 78757,
	"./stable/mob/MiniBoss/092---ShopMimic": 25710,
	"./stable/mob/MiniBoss/092---ShopMimic.json": 25710,
	"./stable/mob/MiniBoss/093---Medusa": 73855,
	"./stable/mob/MiniBoss/093---Medusa.json": 73855,
	"./stable/mob/Ranged/047---Archer": 79065,
	"./stable/mob/Ranged/047---Archer.json": 79065,
	"./stable/mob/Ranged/048---Grenader": 50104,
	"./stable/mob/Ranged/048---Grenader.json": 50104,
	"./stable/mob/Ranged/049---ClusterGrenader": 50757,
	"./stable/mob/Ranged/049---ClusterGrenader.json": 50757,
	"./stable/mob/Ranged/050---Scorpio": 27591,
	"./stable/mob/Ranged/050---Scorpio.json": 27591,
	"./stable/mob/Ranged/051---Hammer": 11345,
	"./stable/mob/Ranged/051---Hammer.json": 11345,
	"./stable/mob/Ranged/052---AxeThrower": 81349,
	"./stable/mob/Ranged/052---AxeThrower.json": 81349,
	"./stable/mob/Ranged/053---PirateChief": 92608,
	"./stable/mob/Ranged/053---PirateChief.json": 92608,
	"./stable/mob/Ranged/054---Spiker": 14612,
	"./stable/mob/Ranged/054---Spiker.json": 14612,
	"./stable/mob/Ranged/055---Mage360": 68257,
	"./stable/mob/Ranged/055---Mage360.json": 68257,
	"./stable/mob/Ranged/056---OrbLauncher": 72945,
	"./stable/mob/Ranged/056---OrbLauncher.json": 72945,
	"./stable/mob/Ranged/057---DeathMage": 12799,
	"./stable/mob/Ranged/057---DeathMage.json": 12799,
	"./stable/mob/Ranged/058---KunaiMaster": 28864,
	"./stable/mob/Ranged/058---KunaiMaster.json": 28864,
	"./stable/mob/Ranged/059---Arbiter": 47634,
	"./stable/mob/Ranged/059---Arbiter.json": 47634,
	"./stable/mob/Ranged/060---Minimoth": 94140,
	"./stable/mob/Ranged/060---Minimoth.json": 94140,
	"./stable/mob/Ranged/061---Pitcher": 59526,
	"./stable/mob/Ranged/061---Pitcher.json": 59526,
	"./stable/mob/Ranged/062---Blowgunner": 43807,
	"./stable/mob/Ranged/062---Blowgunner.json": 43807,
	"./stable/mob/Ranged/063---Hurler": 43402,
	"./stable/mob/Ranged/063---Hurler.json": 43402,
	"./stable/mob/Ranged/064---CrossbowMan": 68911,
	"./stable/mob/Ranged/064---CrossbowMan.json": 68911,
	"./stable/mob/Ranged/065---BootlegHomunculus": 29905,
	"./stable/mob/Ranged/065---BootlegHomunculus.json": 29905,
	"./stable/mob/Ranged/066---BootlegBowman": 77050,
	"./stable/mob/Ranged/066---BootlegBowman.json": 77050,
	"./stable/mob/Ranged/067---AnchorGuy": 6389,
	"./stable/mob/Ranged/067---AnchorGuy.json": 6389,
	"./stable/mob/Ranged/068---BoneThrower": 26023,
	"./stable/mob/Ranged/068---BoneThrower.json": 26023,
	"./stable/mob/Ranged/069---Merman": 21065,
	"./stable/mob/Ranged/069---Merman.json": 21065,
	"./stable/mob/Support/082---EliteSideKick": 73075,
	"./stable/mob/Support/082---EliteSideKick.json": 73075,
	"./stable/mob/Support/083---Shielder": 26640,
	"./stable/mob/Support/083---Shielder.json": 26640,
	"./stable/mob/Support/084---Spawner": 2824,
	"./stable/mob/Support/084---Spawner.json": 2824,
	"./stable/mob/Support/085---Spawnling": 47494,
	"./stable/mob/Support/085---Spawnling.json": 47494,
	"./stable/mob/Support/086---Fogger": 89308,
	"./stable/mob/Support/086---Fogger.json": 89308,
	"./stable/mob/Support/087---Defender": 15040,
	"./stable/mob/Support/087---Defender.json": 15040,
	"./stable/mob/Support/088---Necromant": 69071,
	"./stable/mob/Support/088---Necromant.json": 69071,
	"./stable/mob/Support/089---BonePillar": 66223,
	"./stable/mob/Support/089---BonePillar.json": 66223,
	"./stable/weapon/000---StartSword": 33965,
	"./stable/weapon/000---StartSword.json": 33965,
	"./stable/weapon/001---AdminWeapon": 9474,
	"./stable/weapon/001---AdminWeapon.json": 9474,
	"./stable/weapon/002---QuickSword": 1192,
	"./stable/weapon/002---QuickSword.json": 1192,
	"./stable/weapon/003---RevengeSword": 95739,
	"./stable/weapon/003---RevengeSword.json": 95739,
	"./stable/weapon/004---BleedCrit": 18471,
	"./stable/weapon/004---BleedCrit.json": 18471,
	"./stable/weapon/005---OilSword": 55398,
	"./stable/weapon/005---OilSword.json": 55398,
	"./stable/weapon/006---Burner": 5321,
	"./stable/weapon/006---Burner.json": 5321,
	"./stable/weapon/007---DualDaggers": 67620,
	"./stable/weapon/007---DualDaggers.json": 67620,
	"./stable/weapon/008---BackStabber": 7221,
	"./stable/weapon/008---BackStabber.json": 7221,
	"./stable/weapon/009---LowHealth": 71957,
	"./stable/weapon/009---LowHealth.json": 71957,
	"./stable/weapon/010---Bleeder": 23857,
	"./stable/weapon/010---Bleeder.json": 23857,
	"./stable/weapon/011---BroadSword": 35405,
	"./stable/weapon/011---BroadSword.json": 35405,
	"./stable/weapon/012---Shovel": 61327,
	"./stable/weapon/012---Shovel.json": 61327,
	"./stable/weapon/013---EvilSword": 78003,
	"./stable/weapon/013---EvilSword.json": 78003,
	"./stable/weapon/014---SpeedBlade": 95486,
	"./stable/weapon/014---SpeedBlade.json": 95486,
	"./stable/weapon/015---GiantKiller": 42202,
	"./stable/weapon/015---GiantKiller.json": 42202,
	"./stable/weapon/016---BulletBlade": 20517,
	"./stable/weapon/016---BulletBlade.json": 20517,
	"./stable/weapon/017---SismicBlade": 41154,
	"./stable/weapon/017---SismicBlade.json": 41154,
	"./stable/weapon/018---StunMace": 62318,
	"./stable/weapon/018---StunMace.json": 62318,
	"./stable/weapon/019---BumpBoots": 39223,
	"./stable/weapon/019---BumpBoots.json": 39223,
	"./stable/weapon/020---SpikedBoots": 70819,
	"./stable/weapon/020---SpikedBoots.json": 70819,
	"./stable/weapon/021---MultiKickBoots": 92821,
	"./stable/weapon/021---MultiKickBoots.json": 92821,
	"./stable/weapon/022---QuickFists": 57790,
	"./stable/weapon/022---QuickFists.json": 57790,
	"./stable/weapon/023---Spear": 94802,
	"./stable/weapon/023---Spear.json": 94802,
	"./stable/weapon/024---ImpaleSpear": 5246,
	"./stable/weapon/024---ImpaleSpear.json": 5246,
	"./stable/weapon/025---KingsSpear": 95385,
	"./stable/weapon/025---KingsSpear.json": 95385,
	"./stable/weapon/026---Rapier": 59044,
	"./stable/weapon/026---Rapier.json": 59044,
	"./stable/weapon/027---PerfectHalberd": 55282,
	"./stable/weapon/027---PerfectHalberd.json": 55282,
	"./stable/weapon/028---BehemothHammer": 9809,
	"./stable/weapon/028---BehemothHammer.json": 9809,
	"./stable/weapon/029---DashSword": 36075,
	"./stable/weapon/029---DashSword.json": 36075,
	"./stable/weapon/030---Whip": 37310,
	"./stable/weapon/030---Whip.json": 37310,
	"./stable/weapon/031---HookWhip": 74867,
	"./stable/weapon/031---HookWhip.json": 74867,
	"./stable/weapon/032---TentacleWhip": 82669,
	"./stable/weapon/032---TentacleWhip.json": 82669,
	"./stable/weapon/033---Pan": 89207,
	"./stable/weapon/033---Pan.json": 89207,
	"./stable/weapon/034---MachetePistol": 34117,
	"./stable/weapon/034---MachetePistol.json": 34117,
	"./stable/weapon/035---HardLightSword": 61388,
	"./stable/weapon/035---HardLightSword.json": 61388,
	"./stable/weapon/036---HardLightGun": 80487,
	"./stable/weapon/036---HardLightGun.json": 80487,
	"./stable/weapon/037---ParryBlade": 34987,
	"./stable/weapon/037---ParryBlade.json": 34987,
	"./stable/weapon/038---TickScytheLeft": 44250,
	"./stable/weapon/038---TickScytheLeft.json": 44250,
	"./stable/weapon/039---TickScytheRight": 49069,
	"./stable/weapon/039---TickScytheRight.json": 49069,
	"./stable/weapon/040---RhythmicBlade": 92525,
	"./stable/weapon/040---RhythmicBlade.json": 92525,
	"./stable/weapon/041---Crowbar": 1805,
	"./stable/weapon/041---Crowbar.json": 1805,
	"./stable/weapon/042---SnakeFang": 63695,
	"./stable/weapon/042---SnakeFang.json": 63695,
	"./stable/weapon/043---GiantStaff": 72873,
	"./stable/weapon/043---GiantStaff.json": 72873,
	"./stable/weapon/044---Lantern": 72753,
	"./stable/weapon/044---Lantern.json": 72753,
	"./stable/weapon/045---LanternOffHand": 93474,
	"./stable/weapon/045---LanternOffHand.json": 93474,
	"./stable/weapon/046---FlyingSword": 89654,
	"./stable/weapon/046---FlyingSword.json": 89654,
	"./stable/weapon/047---NotFlyingSword": 50498,
	"./stable/weapon/047---NotFlyingSword.json": 50498,
	"./stable/weapon/048---Tombstone": 22135,
	"./stable/weapon/048---Tombstone.json": 22135,
	"./stable/weapon/049---HeavyAxe": 89209,
	"./stable/weapon/049---HeavyAxe.json": 89209,
	"./stable/weapon/050---Club": 98195,
	"./stable/weapon/050---Club.json": 98195,
	"./stable/weapon/051---ClubBroken": 36202,
	"./stable/weapon/051---ClubBroken.json": 36202,
	"./stable/weapon/052---PureNail": 29007,
	"./stable/weapon/052---PureNail.json": 29007,
	"./stable/weapon/053---SkulBone": 87133,
	"./stable/weapon/053---SkulBone.json": 87133,
	"./stable/weapon/054---StartBow": 37094,
	"./stable/weapon/054---StartBow.json": 37094,
	"./stable/weapon/055---DualBow": 58162,
	"./stable/weapon/055---DualBow.json": 58162,
	"./stable/weapon/056---InfiniteBow": 78033,
	"./stable/weapon/056---InfiniteBow.json": 78033,
	"./stable/weapon/057---LongBow": 23389,
	"./stable/weapon/057---LongBow.json": 23389,
	"./stable/weapon/058---SonicCrossbow": 78773,
	"./stable/weapon/058---SonicCrossbow.json": 78773,
	"./stable/weapon/059---CloseCombatBow": 80868,
	"./stable/weapon/059---CloseCombatBow.json": 80868,
	"./stable/weapon/060---FastBow": 59015,
	"./stable/weapon/060---FastBow.json": 59015,
	"./stable/weapon/061---FrostBow": 26854,
	"./stable/weapon/061---FrostBow.json": 26854,
	"./stable/weapon/062---CrossBow": 36435,
	"./stable/weapon/062---CrossBow.json": 36435,
	"./stable/weapon/063---CrossBowOffHand": 9030,
	"./stable/weapon/063---CrossBowOffHand.json": 9030,
	"./stable/weapon/064---MultiCrossBow": 30000,
	"./stable/weapon/064---MultiCrossBow.json": 30000,
	"./stable/weapon/065---MultiCrossBowOffHand": 19177,
	"./stable/weapon/065---MultiCrossBowOffHand.json": 19177,
	"./stable/weapon/066---FrostCrossBow": 81838,
	"./stable/weapon/066---FrostCrossBow.json": 81838,
	"./stable/weapon/067---FrostCrossBowOffHand": 34998,
	"./stable/weapon/067---FrostCrossBowOffHand.json": 34998,
	"./stable/weapon/068---ExplosiveCrossBow": 23197,
	"./stable/weapon/068---ExplosiveCrossBow.json": 23197,
	"./stable/weapon/069---ExplosiveCrossBowOffHand": 76620,
	"./stable/weapon/069---ExplosiveCrossBowOffHand.json": 76620,
	"./stable/weapon/070---AlchemicGun": 40222,
	"./stable/weapon/070---AlchemicGun.json": 40222,
	"./stable/weapon/071---MarkBow": 64057,
	"./stable/weapon/071---MarkBow.json": 64057,
	"./stable/weapon/072---PreciseBow": 89422,
	"./stable/weapon/072---PreciseBow.json": 89422,
	"./stable/weapon/073---ThrowingKnife": 38406,
	"./stable/weapon/073---ThrowingKnife.json": 38406,
	"./stable/weapon/074---Boomerang": 40231,
	"./stable/weapon/074---Boomerang.json": 40231,
	"./stable/weapon/075---BleedAxe": 69269,
	"./stable/weapon/075---BleedAxe.json": 69269,
	"./stable/weapon/076---GodAxe": 22488,
	"./stable/weapon/076---GodAxe.json": 22488,
	"./stable/weapon/077---ThrowingSpear": 40230,
	"./stable/weapon/077---ThrowingSpear.json": 40230,
	"./stable/weapon/078---Blowgun": 55373,
	"./stable/weapon/078---Blowgun.json": 55373,
	"./stable/weapon/079---MagicBow": 39663,
	"./stable/weapon/079---MagicBow.json": 39663,
	"./stable/weapon/080---StartShield": 31564,
	"./stable/weapon/080---StartShield.json": 31564,
	"./stable/weapon/081---WarriorShield": 22213,
	"./stable/weapon/081---WarriorShield.json": 22213,
	"./stable/weapon/082---Shield": 64634,
	"./stable/weapon/082---Shield.json": 64634,
	"./stable/weapon/083---AreaShield": 96313,
	"./stable/weapon/083---AreaShield.json": 96313,
	"./stable/weapon/084---BumpShield": 20474,
	"./stable/weapon/084---BumpShield.json": 20474,
	"./stable/weapon/085---Rampart": 2839,
	"./stable/weapon/085---Rampart.json": 2839,
	"./stable/weapon/086---GreedShield": 4283,
	"./stable/weapon/086---GreedShield.json": 4283,
	"./stable/weapon/087---DashShield": 35682,
	"./stable/weapon/087---DashShield.json": 35682,
	"./stable/weapon/088---BloodShield": 83836,
	"./stable/weapon/088---BloodShield.json": 83836,
	"./stable/weapon/089---SpikeShield": 57741,
	"./stable/weapon/089---SpikeShield.json": 57741,
	"./stable/weapon/090---ParryShield": 71762,
	"./stable/weapon/090---ParryShield.json": 71762,
	"./stable/weapon/091---HoldShield": 8723,
	"./stable/weapon/091---HoldShield.json": 8723,
	"./stable/weapon/092---ThunderShield": 33979,
	"./stable/weapon/092---ThunderShield.json": 33979,
	"./stable/weapon/093---IceShield": 42609,
	"./stable/weapon/093---IceShield.json": 42609,
	"./stable/weapon/094---MagicSalve": 40483,
	"./stable/weapon/094---MagicSalve.json": 40483,
	"./stable/weapon/095---FireBall": 2079,
	"./stable/weapon/095---FireBall.json": 2079,
	"./stable/weapon/096---Lightning": 66142,
	"./stable/weapon/096---Lightning.json": 66142,
	"./stable/weapon/097---LightningWhip": 85650,
	"./stable/weapon/097---LightningWhip.json": 85650,
	"./stable/weapon/098---FlameThrower": 50054,
	"./stable/weapon/098---FlameThrower.json": 50054,
	"./stable/weapon/099---ThrowingTorch": 51242,
	"./stable/weapon/099---ThrowingTorch.json": 51242,
	"./stable/weapon/100---ThrowingIce": 89992,
	"./stable/weapon/100---ThrowingIce.json": 89992,
	"./stable/weapon/101---Freeze": 86538,
	"./stable/weapon/101---Freeze.json": 86538,
	"./stable/weapon/102---BarrelLauncher": 22081,
	"./stable/weapon/102---BarrelLauncher.json": 22081,
	"./stable/weapon/103---Katana": 47922,
	"./stable/weapon/103---Katana.json": 47922,
	"./stable/weapon/104---Trident": 74234,
	"./stable/weapon/104---Trident.json": 74234,
	"./stable/weapon/105---ThrowingCards": 4965,
	"./stable/weapon/105---ThrowingCards.json": 4965,
	"./stable/weapon/106---HandHook": 75250,
	"./stable/weapon/106---HandHook.json": 75250,
	"./stable/weapon/107---Shark": 81843,
	"./stable/weapon/107---Shark.json": 81843,
	"./stable/weapon/108---ElbowBlades": 32969,
	"./stable/weapon/108---ElbowBlades.json": 32969,
	"./stable/weapon/109---HeavyBow": 27167,
	"./stable/weapon/109---HeavyBow.json": 27167,
	"./stable/weapon/110---WreckingBall": 19925,
	"./stable/weapon/110---WreckingBall.json": 19925,
	"./stable/weapon/111---QueenRapier": 76543,
	"./stable/weapon/111---QueenRapier.json": 76543,
	"./stable/weapon/112---CupidityDagger": 42958,
	"./stable/weapon/112---CupidityDagger.json": 42958,
	"./stable/weapon/113---GoldDigger": 19335,
	"./stable/weapon/113---GoldDigger.json": 19335,
	"./stable/weapon/114---MoneyShooter": 17204,
	"./stable/weapon/114---MoneyShooter.json": 17204,
	"./stable/weapon/115---KingScepter": 74149,
	"./stable/weapon/115---KingScepter.json": 74149,
	"./stable/weapon/116---BaseballBat": 74298,
	"./stable/weapon/116---BaseballBat.json": 74298,
	"./stable/weapon/117---ThrowableStuff": 89056,
	"./stable/weapon/117---ThrowableStuff.json": 89056,
	"./stable/weapon/118---LaserGlaive": 40784,
	"./stable/weapon/118---LaserGlaive.json": 40784,
	"./stable/weapon/119---Starfury": 30619,
	"./stable/weapon/119---Starfury.json": 30619,
	"./stable/weapon/120---HydraSpell": 86323,
	"./stable/weapon/120---HydraSpell.json": 86323,
	"./stable/weapon/121---NunchuckPan": 81788,
	"./stable/weapon/121---NunchuckPan.json": 81788,
	"./stable/weapon/122---Cross": 5822,
	"./stable/weapon/122---Cross.json": 5822,
	"./stable/weapon/123---TPSword": 96947,
	"./stable/weapon/123---TPSword.json": 96947,
	"./stable/weapon/124---ThrowingAxe": 31123,
	"./stable/weapon/124---ThrowingAxe.json": 31123,
	"./stable/weapon/125---WiggleWhip": 50041,
	"./stable/weapon/125---WiggleWhip.json": 50041,
	"./stable/weapon/126---Bible": 82505,
	"./stable/weapon/126---Bible.json": 82505,
	"./stable/weapon/127---SnakeSwordWeapon": 19699,
	"./stable/weapon/127---SnakeSwordWeapon.json": 19699,
	"./stable/weapon/128---SnakeSwordWeaponAlt": 86570,
	"./stable/weapon/128---SnakeSwordWeaponAlt.json": 86570,
	"./stable/weapon/129---SnakeSwordSwap": 93789,
	"./stable/weapon/129---SnakeSwordSwap.json": 93789,
	"./stable/weapon/130---VampireKiller": 10989,
	"./stable/weapon/130---VampireKiller.json": 10989,
	"./stable/weapon/131---AlucardShield": 33940,
	"./stable/weapon/131---AlucardShield.json": 33940,
	"./stable/weapon/132---MedusaHead": 95337,
	"./stable/weapon/132---MedusaHead.json": 95337,
	"./stable/weapon/133---AdeleScythe": 74434,
	"./stable/weapon/133---AdeleScythe.json": 74434,
	"./stable/weapon/134---RichterVampireKiller": 71663,
	"./stable/weapon/134---RichterVampireKiller.json": 71663,
	"./stable/weapon/135---CombinedTickScythe": 52134,
	"./stable/weapon/135---CombinedTickScythe.json": 52134,
	"./stable/weapon/136---Pistol": 64713,
	"./stable/weapon/136---Pistol.json": 64713,
	"./stable/weapon/137---Scissor": 41839,
	"./stable/weapon/137---Scissor.json": 41839,
	"./stable/weapon/138---Comb": 21376,
	"./stable/weapon/138---Comb.json": 21376,
	"./stable/weapon/__PROPS__": 9786,
	"./stable/weapon/__PROPS__.json": 9786,
	"./stable/weapon/__STRUCTURE__": 23730,
	"./stable/weapon/__STRUCTURE__.json": 23730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62114;